import * as React from "react";
import { withTheme } from "styled-components";

import * as Icons from "../../constants/icons";

interface IIconProps {
  name: string;
  color?: string;
  opacity?: number;
  className?: string;
  onClick?: (event: React.SyntheticEvent) => any;
}

interface IProps extends IIconProps {
  theme: any;
  inverted?: boolean;
}

const getIcon = (props: IIconProps) => {
  const { name, color, opacity, className, onClick } = props;
  const icons = {
    [Icons.INBOX]: (
      <svg
        onClick={onClick}
        className={className}
        width="40px"
        height="40px"
        viewBox="0 0 40 40"
        version="1.1"
      >
        <g
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
          opacity={opacity}
        >
          <g>
            <g
              transform="translate(12.000000, 13.000000)"
              stroke={color}
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.2"
            >
              <polyline points="0.5 4 8 8 15.5 4" />
              <path d="M14.5,13.5 L1.5,13.5 C0.948,13.5 0.5,13.052 0.5,12.5 L0.5,1.5 C0.5,0.948 0.948,0.5 1.5,0.5 L14.5,0.5 C15.052,0.5 15.5,0.948 15.5,1.5 L15.5,12.5 C15.5,13.052 15.052,13.5 14.5,13.5 Z" />
            </g>
          </g>
        </g>
      </svg>
    ),
    [Icons.SIMPLE_CHECKMARK]: (
      <svg
        onClick={onClick}
        className={className}
        width="32px"
        height="32px"
        viewBox="0 0 32 32"
        version="1.1"
      >
        <g
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
          opacity={opacity}
        >
          <g>
            <rect fillRule="nonzero" x="0" y="0" width="32" height="32" />
            <g
              transform="translate(12.000000, 13.000000)"
              stroke={color}
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
            >
              <polyline points="0 2.28571429 2.85714286 5.14285714 8 0" />
            </g>
          </g>
        </g>
      </svg>
    ),
    [Icons.CALENDAR]: (
      <svg
        onClick={onClick}
        className={className}
        width="40"
        height="40"
        viewBox="0 0 40 40"
      >
        <g fill="none" fillRule="evenodd" opacity={opacity}>
          <path d="M0 0h40v40H0z" />
          <g stroke={color} strokeLinecap="round" strokeLinejoin="round">
            <path d="M13.5 17.5h14M26.5 14.5h-12a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-11a1 1 0 0 0-1-1zM16.5 12.5v2M24.5 12.5v2M20.5 12.5v2" />
          </g>
        </g>
      </svg>
    ),
    [Icons.CALENDAR_SUBSCRIBE]: (
      <svg
        onClick={onClick}
        className={className}
        width="40"
        height="40"
        viewBox="0 0 40 40"
      >
        <g fill="none" fillRule="evenodd" opacity={opacity}>
          <rect id="padding" x="0" y="0" width="40" height="40"></rect>
          <path
            d="M20,23.5 L27.5,23.5"
            id="Shape"
            stroke={color}
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          ></path>
          <polyline
            id="Shape"
            stroke={color}
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="25 21 27.5 23.5 25 26"
          ></polyline>
          <path
            d="M12.5,17.5 L27.5,17.5"
            id="Shape"
            stroke={color}
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          ></path>
          <path
            d="M27.5,19.5 L27.5,15.5 C27.5,14.948 27.052,14.5 26.5,14.5 L13.5,14.5 C12.948,14.5 12.5,14.948 12.5,15.5 L12.5,26.5 C12.5,27.052 12.948,27.5 13.5,27.5 L22.5,27.5"
            id="Shape"
            stroke={color}
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          ></path>
          <path
            d="M16.5,12.5 L16.5,14.5"
            id="Shape"
            stroke={color}
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          ></path>
          <path
            d="M23.5,12.5 L23.5,14.5"
            id="Shape"
            stroke={color}
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          ></path>
        </g>
      </svg>
    ),
    [Icons.BADGE]: (
      <svg
        onClick={onClick}
        className={className}
        width="40"
        height="40"
        viewBox="0 0 40 40"
      >
        <g fill="none" fillRule="evenodd" opacity={opacity}>
          <path d="M0 0h40v40H0z" />
          <path
            stroke={color}
            strokeWidth="1.2"
            d="M20.53 12.172l6.029 3.48a1 1 0 0 1 .5.867v6.962a1 1 0 0 1-.5.866l-6.03 3.481a1 1 0 0 1-1 0l-6.029-3.48a1 1 0 0 1-.5-.867V16.52a1 1 0 0 1 .5-.866l6.03-3.481a1 1 0 0 1 1 0z"
          />
        </g>
      </svg>
    ),
    [Icons.ATTACHMENT]: (
      <svg
        onClick={onClick}
        className={className}
        width="40"
        height="40"
        viewBox="0 0 40 40"
      >
        <g fill="none" fillRule="evenodd" opacity={opacity}>
          <path d="M0 0h40v40H0z" />
          <path
            stroke={color}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.2"
            d="M20.857 17.357l-3.005 3.005a1.75 1.75 0 0 0 2.475 2.475l4.066-4.066a3.5 3.5 0 1 0-4.95-4.95l-4.419 4.42a5.25 5.25 0 0 0 7.425 7.425l4.065-4.066"
          />
        </g>
      </svg>
    ),
    [Icons.SHIELD]: (
      <svg
        onClick={onClick}
        className={className}
        width="40"
        height="40"
        viewBox="0 0 40 40"
      >
        <g fill="none" fillRule="evenodd" opacity={opacity}>
          <path d="M0 0h40v40H0z" />
          <path
            stroke={color}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.2"
            d="M13 13h14v8a7 7 0 0 1-14 0v-8z"
          />
        </g>
      </svg>
    ),
    [Icons.CIRCLE]: (
      <svg
        onClick={onClick}
        className={className}
        width="40"
        height="40"
        viewBox="0 0 40 40"
      >
        <g fill="none" fillRule="evenodd" opacity={opacity}>
          <path d="M0 0h40v40H0z" />
          <circle
            cx="20"
            cy="20"
            r="7.5"
            stroke={color}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.2"
          />
        </g>
      </svg>
    ),
    [Icons.SUBJECT]: (
      <svg
        onClick={onClick}
        className={className}
        width="40"
        height="40"
        viewBox="0 0 40 40"
      >
        <g fill="none" fillRule="evenodd" opacity={opacity}>
          <path d="M0 0h40v40H0z" />
          <g
            stroke={color}
            strokeLinecap="round"
            strokeLinejoin="round"
            transform="translate(13 12)"
          >
            <rect width="13" height="16" x="1" rx="1" />
            <path d="M0 4h3M0 8h3M0 12h3" />
          </g>
        </g>
      </svg>
    ),
    [Icons.CHANNEL]: (
      <svg
        onClick={onClick}
        className={className}
        width="40"
        height="40"
        viewBox="0 0 40 40"
      >
        <g fill="none" fillRule="evenodd" opacity={opacity}>
          <path d="M0 0h40v40H0z" />
          <path
            stroke={color}
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M14 27.5l6-3 6 3v-13a2 2 0 0 0-2-2h-8a2 2 0 0 0-2 2v13z"
          />
        </g>
      </svg>
    ),
    [Icons.LOCK]: (
      <svg
        onClick={onClick}
        className={className}
        width="40"
        height="40"
        viewBox="0 0 40 40"
      >
        <g fill="none" fillRule="evenodd" opacity={opacity}>
          <path d="M0 0h40v40H0z" />
          <g stroke={color} strokeLinecap="round" strokeLinejoin="round">
            <path d="M25.5 27.5h-11a1 1 0 0 1-1-1v-7a1 1 0 0 1 1-1h11a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1zM16.5 18.5V16a3.5 3.5 0 1 1 7 0v2.5" />
          </g>
        </g>
      </svg>
    ),
    [Icons.BELL]: (
      <svg
        onClick={onClick}
        className={className}
        width="40"
        height="40"
        viewBox="0 0 40 40"
      >
        <g
          fill="none"
          fillRule="evenodd"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.2"
          opacity={opacity}
        >
          <path d="M22 25.5a2 2 0 1 1-4 0M12.5 23.5h15M26.5 23.5h.5c-1.105 0-2.5-.895-2.5-2V17a4.5 4.5 0 0 0-9 0v4.5a2 2 0 0 1-2 2" />
        </g>
      </svg>
    ),
    [Icons.SEARCH]: (
      <svg
        onClick={onClick}
        className={className}
        width="40"
        height="40"
        viewBox="0 0 40 40"
      >
        <g fill="none" fillRule="evenodd" opacity={opacity}>
          <path d="M0 0h40v40H0z" />
          <g
            stroke={color}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.2"
            transform="translate(13 13)"
          >
            <path d="M13.5 13.5l-2.828-2.828" />
            <circle cx="6.5" cy="6.5" r="6" />
          </g>
        </g>
      </svg>
    ),
    [Icons.FAVOURITES]: (
      <svg
        onClick={onClick}
        className={className}
        width="40"
        height="40"
        viewBox="0 0 40 40"
      >
        <g stroke={color} fill="none" fillRule="evenodd" opacity={opacity}>
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.2"
            d="M20 12l2.473 5.01 5.527.802-4 3.899.944 5.506-4.944-2.6-4.944 2.6.944-5.506-4-3.899 5.527-.803z"
          />
        </g>
      </svg>
    ),
    [Icons.IMPORTANT]: (
      <svg
        onClick={onClick}
        className={className}
        width="40"
        height="40"
        viewBox="0 0 40 40"
      >
        <g fill="none" fillRule="evenodd" opacity={opacity}>
          <g transform="translate(12.5 12.5)">
            <circle
              stroke={color}
              cx="7.5"
              cy="7.5"
              r="7.5"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.2"
            />
            <circle cx="7.5" cy="11" r="1" fill={color} fillRule="nonzero" />
            <path
              stroke={color}
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.2"
              d="M7.5 3.5V8"
            />
          </g>
        </g>
      </svg>
    ),
    [Icons.MORE]: (
      <svg
        onClick={onClick}
        className={className}
        width="40"
        height="40"
        viewBox="0 0 40 40"
      >
        <g stroke={color} fill="none" fillRule="evenodd" opacity={opacity}>
          <g
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.2"
            transform="translate(12 18)"
          >
            <circle cx="8" cy="2" r="1.5" />
            <circle cx="14" cy="2" r="1.5" />
            <circle cx="2" cy="2" r="1.5" />
          </g>
        </g>
      </svg>
    ),
    [Icons.READ]: (
      <svg
        onClick={onClick}
        className={className}
        width="40"
        height="40"
        viewBox="0 0 40 40"
      >
        <g stroke={color} fill="none" fillRule="evenodd" opacity={opacity}>
          <circle
            cx="20"
            cy="20"
            r="7.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.2"
          />
        </g>
      </svg>
    ),
    [Icons.EDIT]: (
      <svg
        onClick={onClick}
        className={className}
        width="40px"
        height="40px"
        viewBox="0 0 40 40"
        version="1.1"
      >
        <g
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
          opacity={opacity}
        >
          <g>
            <g transform="translate(8.000000, 8.000000)">
              <path
                d="M12,24 C18.627417,24 24,18.627417 24,12 C24,5.372583 18.627417,0 12,0 C5.372583,0 0,5.372583 0,12 C0,18.627417 5.372583,24 12,24 Z"
                stroke={color}
                opacity="0.300000012"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeDasharray="1,4"
              />
              <g
                transform="translate(7.000000, 7.000000)"
                fill={color}
                fillRule="nonzero"
              >
                <path d="M9.504375,5.495625 L6.066875,2.058125 C5.8225,1.81375 5.4275,1.81375 5.183125,2.058125 L0.808125,6.433125 C0.728125,6.513125 0.67125,6.61375 0.64375,6.723125 L0.01875,9.223125 C-0.034375,9.43625 0.028125,9.66125 0.183125,9.816875 C0.301875,9.935625 0.46125,10 0.625,10 C0.675625,10 0.72625,9.99375 0.776875,9.98125 L3.276875,9.35625 C3.386875,9.32875 3.486875,9.271875 3.566875,9.191875 L7.5,5.25875 L8.17875,5.9375 L6.120625,7.995625 C5.87625,8.24 5.87625,8.635 6.120625,8.879375 C6.365,9.12375 6.76,9.12375 7.004375,8.879375 L9.504375,6.379375 C9.74875,6.135 9.74875,5.74 9.504375,5.495625 Z" />
                <path d="M6.950625,1.174375 L8.825625,3.049375 L9.611875,2.263125 C10.129375,1.745625 10.129375,0.905625 9.611875,0.388125 C9.094375,-0.129375 8.254375,-0.129375 7.736875,0.388125 L6.950625,1.174375 Z" />
              </g>
            </g>
          </g>
        </g>
      </svg>
    ),
    [Icons.PENCIL]: (
      <svg
        onClick={onClick}
        className={className}
        width="40px"
        height="40px"
        viewBox="0 0 40 40"
        version="1.1"
      >
        <g
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
          opacity={opacity}
        >
          <g>
            <path
              d="M25,19 L21,15"
              stroke={color}
              strokeWidth="1.2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <polygon
              stroke={color}
              strokeWidth="1.2"
              strokeLinecap="round"
              strokeLinejoin="round"
              points="17.5 26.5 12.5 27.5 13.5 22.5 23.5 12.5 27.5 16.5"
            />
          </g>
        </g>
      </svg>
    ),
    [Icons.ARCHIVE]: (
      <svg
        onClick={onClick}
        className={className}
        width="40px"
        height="40px"
        viewBox="0 0 40 40"
        version="1.1"
      >
        <g
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
          opacity={opacity}
        >
          <g id="icon-sidemenu" transform="translate(0.000000, -1.000000)">
            <g id="archive-drawer" transform="translate(0.000000, 0.500000)">
              <path
                d="M14.5,13.5 L25.5,13.5"
                stroke={color}
                strokeWidth="1.2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <polyline
                stroke={color}
                strokeWidth="1.2"
                strokeLinecap="round"
                strokeLinejoin="round"
                points="23.5 19.5 23.5 21.5 16.5 21.5 16.5 19.5"
              />
              <rect
                stroke={color}
                strokeWidth="1.2"
                strokeLinecap="round"
                strokeLinejoin="round"
                x="12.5"
                y="16.5"
                width="15"
                height="11"
              />
            </g>
          </g>
        </g>
      </svg>
    ),
    [Icons.LEAVE]: (
      <svg
        onClick={onClick}
        className={className}
        width="40px"
        height="40px"
        viewBox="0 0 40 40"
        version="1.1"
      >
        <g
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
          opacity={opacity}
        >
          <g>
            <g
              transform="translate(12.000000, 13.000000)"
              stroke={color}
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.2"
            >
              <path d="M5.5,7.5 L15.5,7.5" />
              <polyline points="11.5 3.5 15.5 7.5 11.5 11.5" />
              <path d="M8.5,14.5 L1.5,14.5 C0.948,14.5 0.5,14.052 0.5,13.5 L0.5,1.5 C0.5,0.948 0.948,0.5 1.5,0.5 L8.5,0.5" />
            </g>
          </g>
        </g>
      </svg>
    ),
    [Icons.BIGCALENDAR]: (
      <svg
        onClick={onClick}
        className={className}
        width="32px"
        height="32px"
        viewBox="0 0 32 32"
        version="1.1"
      >
        <g
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
          strokeLinecap="round"
          strokeLinejoin="round"
          opacity={opacity}
        >
          <g
            transform="translate(2.000000, 0.000000)"
            stroke={color}
            strokeWidth="1.2"
          >
            <path d="M0.5,13 L27,13" />
            <path d="M25.5714286,2 L2.42857143,2 C1.364,2 0.5,2.99938462 0.5,4.23076923 L0.5,28.7692308 C0.5,30.0006154 1.364,31 2.42857143,31 L25.5714286,31 C26.636,31 27.5,30.0006154 27.5,28.7692308 L27.5,4.23076923 C27.5,2.99938462 26.636,2 25.5714286,2 Z" />
            <g id="Group-2" transform="translate(2.500000, 0.500000)">
              <path d="M1,0 L1,3" />
              <path d="M22,0 L22,3" />
            </g>
          </g>
        </g>
      </svg>
    ),
    [Icons.DISCUSSION]: (
      <svg
        onClick={onClick}
        className={className}
        width="40px"
        height="40px"
        viewBox="0 0 40 40"
        version="1.1"
      >
        <g
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
          opacity={opacity}
        >
          <g>
            <rect x="0" y="0" width="40" height="40" />
            <g
              transform="translate(12.000000, 12.000000)"
              stroke={color}
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.2"
            >
              <path d="M6.5,0.5 C3.186,0.5 0.5,2.739 0.5,5.5 C0.5,6.521 0.869,7.47 1.5,8.262 L1.5,12 L4.073,10.07 C4.815,10.345 5.635,10.5 6.5,10.5 C9.814,10.5 12.5,8.261 12.5,5.5 C12.5,2.739 9.814,0.5 6.5,0.5 Z" />
              <path d="M5.219,12.504 C6.308,13.427 7.824,14 9.5,14 C10.283,14 11.029,13.871 11.715,13.644 L14.5,15.5 L14.5,11.762 C15.131,10.97 15.5,10.022 15.5,9 C15.5,8.091 15.209,7.239 14.701,6.505" />
            </g>
          </g>
        </g>
      </svg>
    ),
    [Icons.PEOPLE]: (
      <svg
        onClick={onClick}
        className={className}
        width="40px"
        height="40px"
        viewBox="0 0 40 40"
        version="1.1"
      >
        <g
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
          opacity={opacity}
        >
          <g>
            <rect x="0" y="0" width="40" height="40" />
          </g>
          <g
            transform="translate(10.000000, 13.000000)"
            stroke={color}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.2"
          >
            <circle cx="10.5" cy="3.5" r="3" />
            <path d="M10.5,8.5 C7.73857625,8.5 5.5,10.7385763 5.5,13.5 L15.5,13.5 C15.5,10.7385763 13.2614237,8.5 10.5,8.5 Z" />
            <g transform="translate(15.000000, 1.000000)">
              <circle cx="2.5" cy="2.5" r="2" />
              <path d="M0.841,7 C1.33242543,6.67302327 1.90973583,6.49902978 2.5,6.5 C4.15685425,6.5 5.5,7.84314575 5.5,9.5 L5.5,10.5 L2.5,10.5" />
            </g>
            <g transform="translate(3.000000, 6.500000) scale(-1, 1) translate(-3.000000, -6.500000) translate(0.000000, 1.000000)">
              <circle cx="2.5" cy="2.5" r="2" />
              <path d="M0.841,7 C1.33242543,6.67302327 1.90973583,6.49902978 2.5,6.5 C4.15685425,6.5 5.5,7.84314575 5.5,9.5 L5.5,10.5 L2.5,10.5" />
            </g>
          </g>
        </g>
      </svg>
    ),
    [Icons.MOVE]: (
      <svg
        onClick={onClick}
        className={className}
        width="40"
        height="40"
        viewBox="0 0 40 40"
      >
        <g
          fill="none"
          fillRule="evenodd"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.2"
          opacity={opacity}
        >
          <path d="M12.5 19.5h15M24 16l3.5 3.5L24 23M12.5 13.5h8M12.5 25.5h8" />
        </g>
      </svg>
    ),
    [Icons.REMOVE]: (
      <svg
        onClick={onClick}
        className={className}
        width="40"
        height="40"
        viewBox="0 0 40 40"
      >
        <g
          fill="none"
          fillRule="evenodd"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.2"
          opacity={opacity}
        >
          <path d="M14.5 18.5v7a2 2 0 0 0 2 2h7a2 2 0 0 0 2-2v-7M12.5 15.5h15M17.5 15.5v-3h5v3" />
        </g>
      </svg>
    ),
    [Icons.HEART]: (
      <svg
        onClick={onClick}
        className={className}
        width="40"
        height="40"
        viewBox="0 0 40 40"
        version="1.1"
      >
        <g
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
          opacity={opacity}
        >
          <g fillRule="nonzero" stroke={color} strokeWidth="1.2">
            <g transform="translate(12.000000, 13.000000)">
              <path d="M8.00001057,13.17427 L14.2577359,7.25773593 C15.7804214,5.73505051 15.7804214,3.26494949 14.2577359,1.74226407 C12.7350505,0.219578644 10.2649495,0.219578644 8.74226407,1.74226407 C8.69780235,1.78672578 8.65797119,1.83523695 8.57507501,1.94408615 C8.5694028,1.95153559 8.5694028,1.95153559 8.563636,1.95911068 C8.51926666,2.01736974 8.49714602,2.04603611 8.46852129,2.08181703 L8,2.66746864 L7.53147871,2.08181703 C7.50285398,2.04603611 7.48073334,2.01736974 7.436364,1.95911068 C7.4305972,1.95153559 7.4305972,1.95153559 7.42492499,1.94408615 C7.34202881,1.83523695 7.30219765,1.78672578 7.25773593,1.74226407 C5.73505051,0.219578644 3.26494949,0.219578644 1.74226407,1.74226407 C0.219578644,3.26494949 0.219578644,5.73505051 1.73022311,7.24602741 L8.00001057,13.17427 Z" />
            </g>
          </g>
        </g>
      </svg>
    ),
    [Icons.COFFEE]: (
      <svg
        onClick={onClick}
        className={className}
        width="40"
        height="40"
        viewBox="0 0 40 40"
      >
        <g fill="none" fillRule="evenodd" opacity={opacity}>
          <path d="M0 0h40v40H0z" />
          <path d="M0 0h40v40H0z" />
          <g
            stroke={color}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.2"
          >
            <path d="M14.5 17.5h10v3a5 5 0 0 1-10 0v-3zM19.5 12.5v2M16.5 12.5v2M22.5 12.5v2M24.5 21.5h1a2 2 0 0 0 2-2v-2h-3M26.5 27.5h-14" />
          </g>
        </g>
      </svg>
    ),
    [Icons.CLOCK]: (
      <svg
        onClick={onClick}
        className={className}
        width="40px"
        height="40px"
        viewBox="0 0 40 40"
      >
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g
            transform="translate(12.500000, 12.500000)"
            stroke={color}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.2"
            opacity={opacity}
          >
            <circle cx="7.5" cy="7.5" r="7" />
            <polyline points="7.5 3.5 7.5 7.5 11.5 7.5" />
          </g>
        </g>
      </svg>
    ),
    [Icons.CLOCK_ONE]: (
      <svg
        onClick={onClick}
        className={className}
        width="40px"
        height="40px"
        viewBox="0 0 40 40"
      >
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g>
            <g
              transform="translate(12.500000, 12.500000)"
              stroke={color}
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.2"
              opacity={opacity}
            >
              <circle cx="7.5" cy="7.5" r="7" />
              <polyline points="7.5 3.5 7.5 7.5 9.5 4.0996691" />
            </g>
          </g>
        </g>
      </svg>
    ),
    [Icons.CLOCK_TWO]: (
      <svg
        onClick={onClick}
        className={className}
        width="40px"
        height="40px"
        viewBox="0 0 40 40"
      >
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g>
            <g
              transform="translate(12.500000, 12.500000)"
              stroke={color}
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.2"
              opacity={opacity}
            >
              <circle cx="7.5" cy="7.5" r="7" />
              <polyline points="7.5 3.5 7.5 7.5 10.1598104 5.10491422" />
            </g>
          </g>
        </g>
      </svg>
    ),
    [Icons.CLOCK_FOUR]: (
      <svg
        onClick={onClick}
        className={className}
        width="40px"
        height="40px"
        viewBox="0 0 40 40"
      >
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g>
            <g
              transform="translate(12.500000, 12.500000)"
              stroke={color}
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.2"
              opacity={opacity}
            >
              <circle cx="7.5" cy="7.5" r="7" />
              <polyline points="7.5 3.5 7.5 7.5 10.230049 10.203236" />
            </g>
          </g>
        </g>
      </svg>
    ),
    [Icons.CLOCK_EIGHT]: (
      <svg
        onClick={onClick}
        className={className}
        width="40px"
        height="40px"
        viewBox="0 0 40 40"
      >
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g transform="translate(20.000000, 20.000000) scale(-1, 1) translate(-20.000000, -20.000000) ">
            <g
              transform="translate(12.500000, 12.500000)"
              stroke={color}
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.2"
              opacity={opacity}
            >
              <circle cx="7.5" cy="7.5" r="7" />
              <polyline points="7.5 3.5 7.5 7.5 10.230049 10.203236" />
            </g>
          </g>
        </g>
      </svg>
    ),
    [Icons.SETTINGS]: (
      <svg
        onClick={onClick}
        className={className}
        width="40px"
        height="40px"
        viewBox="0 0 40 40"
        version="1.1"
      >
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g>
            <g
              transform="translate(12.000000, 12.000000)"
              stroke={color}
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.2"
              opacity={opacity}
            >
              <circle cx="8" cy="8" r="3.1" />
              <path d="M13.7935371,9.89282493 C13.6962664,10.1911359 13.5765427,10.4802613 13.4353124,10.7583342 L14.7934586,12.6620695 L12.6608393,14.7946888 L10.7580946,13.4354341 C10.4800952,13.5766115 10.1910502,13.6962944 9.89282493,13.7935371 L9.50823787,16.1 L6.49176213,16.1 L6.10717507,13.7935371 C5.80889977,13.6962781 5.51980785,13.5765713 5.24176562,13.4353631 L3.33902636,14.7935545 L1.2064455,12.6609736 L2.56463689,10.7582344 C2.42342867,10.4801922 2.30372194,10.1911002 2.2064629,9.89282493 L-0.1,9.50823787 L-0.1,6.49176213 L2.2064629,6.10717507 C2.30372194,5.80889977 2.42342867,5.51980785 2.56463689,5.24176562 L1.2064455,3.33902636 L3.33902636,1.2064455 L5.24176562,2.56463689 C5.51980785,2.42342867 5.80889977,2.30372194 6.10717507,2.2064629 L6.49176213,-0.1 L9.50823787,-0.1 L9.89282493,2.2064629 C10.1911002,2.30372194 10.4801922,2.42342867 10.7582344,2.56463689 L12.6608255,1.20655128 L14.7947947,3.33901247 L13.4354341,5.24190544 C13.5766115,5.51990476 13.6962944,5.80894977 13.7935371,6.10717507 L16.1,6.49176213 L16.1,9.50823787 L13.7935371,9.89282493 Z" />
            </g>
          </g>
        </g>
      </svg>
    ),
    [Icons.NOTIFICATION]: (
      <svg
        onClick={onClick}
        className={className}
        width="40"
        height="40"
        viewBox="0 0 40 40"
      >
        <g fill="none" fillRule="evenodd">
          <path d="M0 0h40v40H0z" />
          <path d="M0 0h40v40H0z" />
          <g
            stroke={color}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.2"
            opacity={opacity}
          >
            <path d="M24.5 17.296V17a4.5 4.5 0 0 0-9 0v.296a3.981 3.981 0 0 1-1.992 3.454c-.641.368-1.008.794-1.008 1.25 0 1.381 3.358 2.5 7.5 2.5 4.142 0 7.5-1.119 7.5-2.5 0-.456-.367-.882-1.008-1.25a3.98 3.98 0 0 1-1.992-3.454zM22.292 26a2.501 2.501 0 0 1-4.584.001" />
          </g>
        </g>
      </svg>
    ),
    [Icons.SNOOZED_NOTIFICATION]: (
      <svg
        onClick={onClick}
        className={className}
        width="40"
        height="40"
        viewBox="0 0 40 40"
      >
        <defs>
          <rect width="1.2" height="20" x="19" y="10" rx=".6" />
          <filter
            width="266.7%"
            height="105%"
            x="-125%"
            y="-2.5%"
            filterUnits="objectBoundingBox"
          >
            <feOffset dx="-1" in="SourceAlpha" result="shadowOffsetOuter1" />
            <feColorMatrix
              in="shadowOffsetOuter1"
              values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
            />
          </filter>
        </defs>
        <g fill="none" fillRule="evenodd">
          <path d="M0 0h40v40H0z" />
          <path d="M0 0h40v40H0z" />
          <g
            stroke={color}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.2"
            opacity={opacity}
          >
            <path d="M24.5 17.296V17a4.5 4.5 0 0 0-9 0v.296a3.981 3.981 0 0 1-1.992 3.454c-.641.368-1.008.794-1.008 1.25 0 1.381 3.358 2.5 7.5 2.5 4.142 0 7.5-1.119 7.5-2.5 0-.456-.367-.882-1.008-1.25a3.98 3.98 0 0 1-1.992-3.454zM22.292 26a2.501 2.501 0 0 1-4.584.001" />
          </g>
          <g transform="rotate(45 19.6 20)">
            <use fill="#000" filter="url(#a)" xlinkHref="#b" />
            <use fill={color} xlinkHref="#b" />
          </g>
        </g>
      </svg>
    ),
    [Icons.RIGHT_ARROW]: (
      <svg
        onClick={onClick}
        className={className}
        width="40px"
        height="40px"
        viewBox="0 0 40 40"
        version="1.1"
      >
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g>
            <rect x="0" y="0" width="40" height="40" />
            <polyline
              stroke={color}
              strokeWidth="1.2"
              strokeLinecap="round"
              strokeLinejoin="round"
              transform="rotate(270,20,20)"
              points="14 17 20 23 26 17"
              opacity={opacity}
            />
          </g>
        </g>
      </svg>
    ),
    [Icons.LEFT_ARROW]: (
      <svg
        onClick={onClick}
        className={className}
        width="40px"
        height="40px"
        viewBox="0 0 40 40"
        version="1.1"
      >
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g>
            <rect x="0" y="0" width="40" height="40" />
            <polyline
              stroke={color}
              strokeWidth="1.2"
              strokeLinecap="round"
              strokeLinejoin="round"
              transform="rotate(90,20,20)"
              points="14 17 20 23 26 17"
              opacity={opacity}
            />
          </g>
        </g>
      </svg>
    ),
    [Icons.DOWN_ARROW]: (
      <svg
        onClick={onClick}
        className={className}
        width="40px"
        height="40px"
        viewBox="0 0 40 40"
        version="1.1"
      >
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g>
            <rect x="0" y="0" width="40" height="40" />
            <polyline
              stroke={color}
              opacity={opacity}
              strokeWidth="1.2"
              strokeLinecap="round"
              strokeLinejoin="round"
              points="14 17 20 23 26 17"
            />
          </g>
        </g>
      </svg>
    ),
    [Icons.LEFT_ANGLE]: (
      <svg
        onClick={onClick}
        width="40px"
        height="40px"
        viewBox="0 0 40 40"
        version="1.1"
        className={className}
      >
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <rect x="0" y="0" width="40" height="40" />
          <g
            opacity={opacity}
            transform="translate(20.000000, 20.500000) scale(-1, 1) translate(-20.000000, -20.500000) translate(12.000000, 15.000000)"
            stroke={color}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.5"
          >
            <path d="M0.5,5.5 L15.5,5.5" />
            <polyline
              stroke={color}
              opacity={opacity}
              strokeWidth="1.2"
              strokeLinecap="round"
              strokeLinejoin="round"
              points="10.5 0.5 15.5 5.5 10.5 10.5"
            />
          </g>
        </g>
      </svg>
    ),
    [Icons.RIGHT_ANGLE]: (
      <svg
        onClick={onClick}
        width="40px"
        height="40px"
        viewBox="0 0 40 40"
        version="1.1"
        className={className}
      >
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <rect x="0" y="0" width="40" height="40" />
          <g
            opacity={opacity}
            transform="translate(12.000000, 15.000000)"
            stroke={color}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.5"
          >
            <path d="M0.5,5.5 L15.5,5.5" />
            <polyline
              stroke={color}
              opacity={opacity}
              strokeWidth="1.2"
              strokeLinecap="round"
              strokeLinejoin="round"
              points="10.5 0.5 15.5 5.5 10.5 10.5"
            />
          </g>
        </g>
      </svg>
    ),
    [Icons.ADD]: (
      <svg
        onClick={onClick}
        className={className}
        width="40px"
        height="40px"
        viewBox="0 0 40 40"
        version="1.1"
      >
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g
            transform="translate(8.000000, 8.000000)"
            stroke={color}
            strokeLinecap="round"
            strokeLinejoin="round"
            opacity={opacity}
          >
            <path
              d="M12,24 C18.627417,24 24,18.627417 24,12 C24,5.372583 18.627417,0 12,0 C5.372583,0 0,5.372583 0,12 C0,18.627417 5.372583,24 12,24 Z"
              strokeDasharray="1,4"
              opacity={0.3}
            />
            <g transform="translate(8.000000, 8.000000)" strokeWidth="1.2">
              <g>
                <path d="M4,0 L4,8" />
                <path d="M0,4 L8,4" />
              </g>
            </g>
          </g>
        </g>
      </svg>
    ),
    [Icons.HOURGLASS]: (
      <svg
        onClick={onClick}
        width="40px"
        height="40px"
        viewBox="0 0 40 40"
        version="1.1"
      >
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g transform="translate(-0.500000, 0.000000)">
            <rect x="0.5" y="0" width="40" height="40" />
            <g
              transform="translate(15.764706, 13.882353)"
              stroke={color}
              opacity={opacity}
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.2"
            >
              <path d="M9.55017301,12.8719723 C9.55017301,12.8719723 9.55017301,12.2208997 9.55017301,12.0415225 C9.55017301,9.68055363 8.75709343,7.56539792 7.47404844,6.64359862 C8.75709343,5.72179931 9.55017301,3.6066436 9.55017301,1.24567474 C9.55017301,1.06629758 9.55017301,0.415224913 9.55017301,0.415224913" />
              <path d="M0.311418685,12.8719723 C0.311418685,12.8719723 0.311418685,12.2208997 0.311418685,12.0415225 C0.311418685,9.68055363 1.10449827,7.56539792 2.38754325,6.64359862 C1.10449827,5.72179931 0.311418685,3.6066436 0.311418685,1.24567474 C0.311418685,1.06629758 0.311418685,0.415224913 0.311418685,0.415224913" />
            </g>
            <path
              d="M14.4152249,14.2975779 L26.7681661,14.2975779"
              stroke={color}
              opacity={opacity}
              strokeWidth="1.2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M14.4152249,26.7543253 L26.7681661,26.7543253"
              stroke={color}
              opacity={opacity}
              strokeWidth="1.2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
        </g>
      </svg>
    ),
    [Icons.MEDICAL]: (
      <svg
        onClick={onClick}
        width="40px"
        height="40px"
        viewBox="0 0 40 40"
        version="1.1"
      >
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g
            transform="translate(12.500000, 13.000000)"
            stroke={color}
            opacity={opacity}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.2"
          >
            <polyline points="5.5 3.5 5.5 0.5 9.5 0.5 9.5 3.5" />
            <rect x="0.5" y="3.5" width="14" height="10" rx="1" />
            <path d="M7.5,6.5 L7.5,10.5" />
            <path d="M5.5,8.5 L9.5,8.5" />
          </g>
        </g>
      </svg>
    ),
    [Icons.PROFILE]: (
      <svg
        onClick={onClick}
        width="40px"
        height="40px"
        viewBox="0 0 40 40"
        version="1.1"
      >
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g>
            <g
              transform="translate(13.000000, 12.000000)"
              stroke={color}
              opacity={opacity}
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.2"
            >
              <path d="M3.318,9 C1.59404106,9.83615816 0.499526319,11.5839638 0.5,13.5 C0.5,13.5 2.5,15.5 7,15.5 C11.5,15.5 13.5,13.5 13.5,13.5 C13.5002879,11.5837377 12.4053481,9.83587359 10.681,9" />
              <path d="M10.5,4 C10.5,5.933 8.933,8.5 7,8.5 C5.067,8.5 3.5,5.933 3.5,4 C3.5,2.06700338 5.06700338,0.5 7,0.5 C8.93299662,0.5 10.5,2.06700338 10.5,4 Z" />
            </g>
          </g>
        </g>
      </svg>
    ),
    [Icons.PAYMENT]: (
      <svg
        onClick={onClick}
        width="40px"
        height="40px"
        viewBox="0 0 40 40"
        version="1.1"
      >
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g
            transform="translate(12.000000, 12.000000)"
            stroke={color}
            opacity={opacity}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.2"
          >
            <circle cx="11" cy="10" r="1.5" />
            <path d="M0.5,2.5 L0.5,13.5 C0.5,14.6045695 1.3954305,15.5 2.5,15.5 L15.5,15.5 L15.5,4.5 L2.5,4.5 C1.3954305,4.5 0.5,3.6045695 0.5,2.5 C0.5,1.3954305 1.3954305,0.5 2.5,0.5 L11.5,0.5 L11.5,2.5" />
          </g>
        </g>
      </svg>
    ),
    [Icons.ANNOUNCEMENT]: (
      <svg
        onClick={onClick}
        className={className}
        width="40"
        height="40"
        viewBox="0 0 40 40"
        version="1.1"
      >
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g>
            <g
              transform="translate(12.000000, 13.000000)"
              stroke={color}
              opacity={opacity}
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.2"
            >
              <polyline points="8.5 13.5 8.5 14.5 2.5 14.5 2.5 12.5" />
              <polygon points="15.5 13.5 0.5 9.5 0.5 4.5 15.5 0.5" />
            </g>
          </g>
        </g>
      </svg>
    ),
    [Icons.CLOSE]: (
      <svg
        onClick={onClick}
        className={className}
        width="40px"
        height="40px"
        viewBox="0 0 40 40"
      >
        <g
          strokeWidth="2"
          fill="none"
          fillRule="evenodd"
          stroke={color}
          opacity={opacity}
        >
          <path d="M 14,14 L 27,27 M 27,14 L 14,27" />
        </g>
      </svg>
    ),
    [Icons.CLOSE_SMALL]: (
      <svg
        onClick={onClick}
        className={className}
        width="10px"
        height="10px"
        viewBox="0 0 10 10"
        version="1.1"
      >
        <g
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <g
            transform="translate(-971.000000, -226.000000)"
            stroke={color}
            opacity={opacity}
            strokeWidth="2"
          >
            <g transform="translate(380.000000, 105.000000)">
              <g transform="translate(0.000000, 94.000000)">
                <g transform="translate(576.000000, 12.000000)">
                  <g transform="translate(16.000000, 16.000000)">
                    <g>
                      <path d="M7.5,0.5 L0.5,7.5" />
                      <path d="M0.5,0.5 L7.5,7.5" />
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
    ),
    [Icons.EMOJI]: (
      <svg
        onClick={onClick}
        className={className}
        width="40"
        height="40"
        viewBox="0 0 40 40"
      >
        <g fill="none" fillRule="evenodd" opacity={opacity}>
          <g transform="translate(12 12)">
            <circle
              cx="8"
              cy="8"
              r="7.5"
              stroke={color}
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.2"
            />
            <circle cx="5" cy="6" r="1" fill={color} fillRule="nonzero" />
            <circle cx="11" cy="6" r="1" fill={color} fillRule="nonzero" />
            <path
              stroke={color}
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.2"
              d="M11 9.8a3.5 3.5 0 0 1-6 0"
            />
          </g>
        </g>
      </svg>
    ),
    [Icons.STUDENTS]: (
      <svg
        onClick={onClick}
        className={className}
        width="24px"
        height="20px"
        viewBox="0 0 24 20"
        version="1.1"
      >
        <g
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
          opacity={opacity}
        >
          <g transform="translate(-24.000000, -107.000000)">
            <g transform="translate(0.000000, 88.000000)">
              <g>
                <g transform="translate(16.000000, 8.000000)">
                  <rect x="0" y="0" width="40" height="40" />
                  <g
                    transform="translate(9.000000, 11.000000)"
                    stroke={color}
                    strokeLinecap="square"
                    strokeWidth="1.2"
                  >
                    <path d="M18,19 L22,19 L22,14.677 C21.9997412,14.2681728 21.7506505,13.9006748 21.371,13.749 L17.629,12.249 C17.2500254,12.0975967 17.001075,11.7310974 17,11.323 L17,10.445 C18.2344135,9.73660134 18.9968908,8.42323424 19,7 L19,5 C19.000321,3.57077716 18.2380521,2.24997496 17.0003891,1.53522455 C15.762726,0.820474126 14.2377433,0.820388527 13,1.535" />
                    <path d="M13.371,14.749 L9.629,13.249 C9.25002543,13.0975967 9.00107504,12.7310974 9,12.323 L9,11.872 C12.27,11.435 13,10 13,10 C13,10 11,8 11,6 C11,3.790861 9.209139,2 7,2 C4.790861,2 3,3.790861 3,6 C3,8 1,10 1,10 C1,10 1.73,11.435 5,11.872 L5,12.323 C4.99974123,12.7318272 4.75065048,13.0993252 4.371,13.251 L0.629,14.751 C0.250025427,14.9024033 0.00107503532,15.2689026 0,15.677 L0,19 L14,19 L14,15.677 C13.9997412,15.2681728 13.7506505,14.9006748 13.371,14.749 Z" />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
    ),
    [Icons.CONTACT]: (
      <svg
        onClick={onClick}
        width="24px"
        height="24px"
        viewBox="0 0 24 24"
        version="1.1"
      >
        <g
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
          opacity={opacity}
        >
          <g transform="translate(-24.000000, -160.000000)">
            <g transform="translate(0.000000, 88.000000)">
              <g transform="translate(0.000000, 56.000000)">
                <g transform="translate(16.000000, 8.000000)">
                  <rect x="0" y="0" width="40" height="40" />
                  <g
                    transform="translate(9.000000, 9.000000)"
                    stroke={color}
                    strokeLinecap="square"
                    strokeWidth="1.2"
                  >
                    <path d="M16,14 L13,17 L5,9 L8,6 L3,1 L0,4 C0,13.941 8.059,22 18,22 L21,19 L16,14 Z" />
                    <path d="M13,0 C17.971,0 22,4.029 22,9" />
                    <path d="M13,4 C15.761,4 18,6.239 18,9" />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
    ),
    [Icons.DOCTOR]: (
      <svg
        onClick={onClick}
        width="24px"
        height="24px"
        viewBox="0 0 24 24"
        version="1.1"
      >
        <g
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
          opacity={opacity}
        >
          <g transform="translate(-24.000000, -216.000000)">
            <g transform="translate(0.000000, 88.000000)">
              <g transform="translate(0.000000, 112.000000)">
                <g transform="translate(36.000000, 28.000000) scale(-1, 1) translate(-36.000000, -28.000000) translate(16.000000, 8.000000)">
                  <rect x="0" y="0" width="40" height="40" />
                  <g
                    transform="translate(9.000000, 9.000000)"
                    stroke={color}
                    strokeLinecap="square"
                    strokeWidth="1.2"
                  >
                    <polyline points="7 15 7 22 19 22 19 16" />
                    <circle cx="19" cy="13" r="3" />
                    <path d="M10,1 L12.8,1 C13.4,1 13.9,1.5 13.8,2.1 L12.2,13.2 C12.1,14.2 11.2,14.9 10.2,14.9 L3.7,14.9 C2.7,14.9 1.9,14.2 1.7,13.2 L0.2,2.1 C0.1,1.5 0.5,1 1.2,1 L4,1" />
                    <path d="M4,0 L4,2" />
                    <path d="M10,0 L10,2" />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
    ),
    [Icons.INSURANCE]: (
      <svg
        onClick={onClick}
        width="22px"
        height="22px"
        viewBox="0 0 22 22"
        version="1.1"
      >
        <g
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
          opacity={opacity}
        >
          <g transform="translate(-25.000000, -273.000000)">
            <g transform="translate(0.000000, 88.000000)">
              <g transform="translate(0.000000, 167.000000)">
                <g transform="translate(16.000000, 9.000000)">
                  <rect x="0" y="0" width="40" height="40" />
                  <g
                    transform="translate(10.000000, 10.000000)"
                    stroke={color}
                    strokeWidth="1.2"
                  >
                    <path d="M10,0 L10,20" />
                    <path d="M18.904,10 L1.096,10" />
                    <path
                      d="M10,0 C7,2 3,3 0,3 C0,10 3,17 10,20 C17,17 20,10 20,3 C17,3 13,2 10,0 Z"
                      strokeLinecap="square"
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
    ),
    [Icons.CONDITION]: (
      <svg
        onClick={onClick}
        width="24px"
        height="24px"
        viewBox="0 0 24 24"
        version="1.1"
      >
        <g
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
          opacity={opacity}
        >
          <g transform="translate(-24.000000, -327.000000)">
            <g transform="translate(0.000000, 88.000000)">
              <g transform="translate(0.000000, 223.000000)">
                <g transform="translate(16.000000, 8.000000)">
                  <rect x="0" y="0" width="40" height="40" />
                  <g
                    transform="translate(9.000000, 9.000000)"
                    stroke={color}
                    strokeLinecap="square"
                    strokeWidth="1.2"
                  >
                    <path d="M13,22 L9,22 C7.9,22 7,21.1 7,20 L7,2 C7,0.9 7.9,0 9,0 L13,0 C14.1,0 15,0.9 15,2 L15,20 C15,21.1 14.1,22 13,22 Z" />
                    <path d="M0,13 L0,9 C0,7.9 0.9,7 2,7 L20,7 C21.1,7 22,7.9 22,9 L22,13 C22,14.1 21.1,15 20,15 L2,15 C0.9,15 0,14.1 0,13 Z" />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
    ),
    [Icons.BIG_HEART]: (
      <svg
        onClick={onClick}
        width="24px"
        height="23px"
        viewBox="0 0 24 23"
        version="1.1"
      >
        <g
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
          opacity={opacity}
        >
          <g transform="translate(-24.000000, -384.000000)">
            <g transform="translate(0.000000, 88.000000)">
              <g transform="translate(0.000000, 279.000000)">
                <g transform="translate(16.000000, 8.000000)">
                  <rect x="0" y="0" width="40" height="40" />
                  <g
                    transform="translate(9.000000, 10.000000)"
                    stroke={color}
                    strokeLinecap="square"
                    strokeWidth="1.2"
                  >
                    <path d="M16,0 C13.9,0 12.1,1.1 11,2.7 C9.9,1.1 8.1,0 6,0 C2.7,0 0,2.7 0,6 C0,12 11,21 11,21 C11,21 22,12 22,6 C22,2.7 19.3,0 16,0 Z" />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
    ),
    [Icons.ALLERGIES]: (
      <svg
        onClick={onClick}
        width="22px"
        height="24px"
        viewBox="0 0 22 24"
        version="1.1"
      >
        <g
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
          opacity={opacity}
        >
          <g transform="translate(-25.000000, -439.000000)">
            <g transform="translate(0.000000, 88.000000)">
              <g transform="translate(0.000000, 335.000000)">
                <g transform="translate(16.000000, 8.000000)">
                  <rect x="0" y="0" width="40" height="40" />
                  <g transform="translate(9.000000, 8.000000)">
                    <path
                      d="M10.082,10.587 C10.3170622,10.1237626 10.5822999,9.67646631 10.876,9.248 C13.7,5.121 17.87,4.339 19.52,5.469 C21.17,6.599 21.953,10.769 19.129,14.894 C16.537,18.683 12.809,19.653 10.939,18.912"
                      stroke={color}
                      strokeWidth="1.2"
                    />
                    <path
                      d="M19.52,5.469 L10.999,17.922"
                      stroke={color}
                      strokeWidth="1.2"
                    />
                    <circle
                      fill={color}
                      fillRule="nonzero"
                      cx="6"
                      cy="15"
                      r="1"
                    />
                    <circle
                      fill={color}
                      fillRule="nonzero"
                      cx="4"
                      cy="18"
                      r="1"
                    />
                    <circle
                      fill={color}
                      fillRule="nonzero"
                      cx="8"
                      cy="18"
                      r="1"
                    />
                    <path
                      d="M11,6 C11.0958378,4.6468055 10.5999125,3.31858708 9.64066269,2.35933731 C8.68141292,1.40008754 7.3531945,0.904162207 6,1 C4.6468055,0.904162207 3.31858708,1.40008754 2.35933731,2.35933731 C1.40008754,3.31858708 0.904162207,4.6468055 1,6 C1,8 2,9 2,12 C2,15 1,16 1,18 C0.904162207,19.3531945 1.40008754,20.6814129 2.35933731,21.6406627 C3.31858708,22.5999125 4.6468055,23.0958378 6,23 C7.3531945,23.0958378 8.68141292,22.5999125 9.64066269,21.6406627 C10.5999125,20.6814129 11.0958378,19.3531945 11,18 C11,16 10,15 10,12 C10,9 11,8 11,6 Z"
                      stroke={color}
                      strokeWidth="1.2"
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
    ),
    [Icons.LUNGS]: (
      <svg
        onClick={onClick}
        width="24px"
        height="23px"
        viewBox="0 0 24 23"
        version="1.1"
      >
        <g
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
          opacity={opacity}
        >
          <g transform="translate(-24.000000, -495.000000)">
            <g transform="translate(0.000000, 88.000000)">
              <g transform="translate(0.000000, 391.000000)">
                <g transform="translate(16.000000, 8.000000)">
                  <rect x="0" y="0" width="40" height="40" />
                  <g
                    transform="translate(9.000000, 9.000000)"
                    stroke={color}
                    strokeWidth="1.2"
                  >
                    <path d="M10,10.6 C10,11.3 10,12.1 10,13 C10,18 7.3,21.4 4.3,21 C1.3,20.6 -0.3,16 0.4,11 C1.1,6 4.1,3 7,3 C7.8,3 8.6,3.3 9,4" />
                    <path d="M12,10.6 C12,11.3 12,12.1 12,13 C12,18 14.7,21.4 17.7,21 C20.7,20.6 22.3,16 21.6,11 C20.9,6 17.9,3 15,3 C14.2,3 13.4,3.3 13,4" />
                    <path
                      d="M17,8 C14.8,8 13,6.2 13,4 L13,0"
                      strokeLinecap="square"
                    />
                    <path
                      d="M5,12 C8.8,10.1 13.2,10.1 17,12"
                      strokeLinecap="square"
                    />
                    <path
                      d="M9,0 L9,4 C9,6.2 7.2,8 5,8"
                      strokeLinecap="square"
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
    ),
    [Icons.SYRINGE]: (
      <svg
        onClick={onClick}
        width="24px"
        height="24px"
        viewBox="0 0 24 24"
        version="1.1"
      >
        <g
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
          opacity={opacity}
        >
          <g transform="translate(-24.000000, -551.000000)">
            <g transform="translate(0.000000, 88.000000)">
              <g transform="translate(0.000000, 447.000000)">
                <g transform="translate(16.000000, 8.000000)">
                  <rect x="0" y="0" width="40" height="40" />
                  <g
                    transform="translate(9.000000, 9.000000)"
                    stroke={color}
                    strokeWidth="1.2"
                  >
                    <path d="M5.7,16.3 L0.7,21.3" strokeLinecap="square" />
                    <path d="M10.6,7.1 L12.1,8.5" strokeLinecap="square" />
                    <path d="M8.5,9.2 L9.9,10.6" strokeLinecap="square" />
                    <path d="M6.4,11.4 L7.8,12.8" strokeLinecap="square" />
                    <path d="M17,7.8 L20.5,4.3" />
                    <path d="M17.7,1.5 L14.2,5" />
                    <path d="M10.6,1.5 L20.5,11.4" strokeLinecap="square" />
                    <path d="M17,0.7 L21.3,5" strokeLinecap="square" />
                    <polyline
                      strokeLinecap="square"
                      points="17.7 8.5 7.8 18.4 3.6 14.2 13.5 4.3"
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
    ),
    [Icons.PAPER]: (
      <svg
        onClick={onClick}
        className={className}
        width="22px"
        height="24px"
        viewBox="0 0 22 24"
        version="1.1"
      >
        <g
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
          opacity={opacity}
        >
          <g transform="translate(-25.000000, -607.000000)">
            <g transform="translate(0.000000, 88.000000)">
              <g transform="translate(0.000000, 503.000000)">
                <g transform="translate(16.000000, 8.000000)">
                  <polygon points="0 0 40 0 40 40 0 40" />
                  <g
                    transform="translate(10.000000, 9.000000)"
                    stroke={color}
                    strokeLinecap="square"
                    strokeWidth="1.2"
                  >
                    <path d="M5,18 L5,19.5 C5,21.75 2.5,22 2.5,22 C2.5,22 17.329,22 17.5,22 C18.881,22 20,20.881 20,19.5 L20,18 L5,18 Z" />
                    <path d="M17,15 L17,0 L0,0 L0,19.5 C0,20.881 1.119,22 2.5,22 L4,22" />
                    <path d="M5,5 L12,5" />
                    <path d="M5,9 L12,9" />
                    <path d="M5,13 L12,13" />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
    ),
    [Icons.PAPER_BIG]: (
      <svg
        onClick={onClick}
        className={className}
        width="40"
        height="40"
        viewBox="0 0 40 40"
        version="1.1"
      >
        <g
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
          opacity={opacity}
        >
          <polygon points="0 0 40 0 40 40 0 40" />
          <g
            transform="translate(10.000000, 9.000000)"
            stroke={color}
            strokeLinecap="square"
            strokeWidth="1.2"
          >
            <path d="M5,18 L5,19.5 C5,21.75 2.5,22 2.5,22 C2.5,22 17.329,22 17.5,22 C18.881,22 20,20.881 20,19.5 L20,18 L5,18 Z" />
            <path d="M17,15 L17,0 L0,0 L0,19.5 C0,20.881 1.119,22 2.5,22 L4,22" />
            <path d="M5,5 L12,5" />
            <path d="M5,9 L12,9" />
            <path d="M5,13 L12,13" />
          </g>
        </g>
      </svg>
    ),
    [Icons.BIG_STAR]: (
      <svg
        onClick={onClick}
        width="22px"
        height="22px"
        viewBox="0 0 22 22"
        version="1.1"
      >
        <g
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
          opacity={opacity}
        >
          <g transform="translate(-25.000000, -664.000000)">
            <g transform="translate(0.000000, 88.000000)">
              <g transform="translate(0.000000, 559.000000)">
                <g transform="translate(16.000000, 8.000000)">
                  <polygon points="0 0 40 0 40 40 0 40" />
                  <g
                    transform="translate(10.000000, 10.000000)"
                    stroke={color}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.2"
                  >
                    <polygon points="10 0.489 13.09 6.751 20 7.755 15 12.629 16.18 19.511 10 16.261 3.82 19.511 5 12.629 0 7.755 6.91 6.751" />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
    ),
    [Icons.DOCUMENT_CHECK]: (
      <svg
        onClick={onClick}
        width="22px"
        height="24px"
        viewBox="0 0 22 24"
        version="1.1"
      >
        <g
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
          opacity={opacity}
        >
          <g transform="translate(-25.000000, -719.000000)">
            <g transform="translate(0.000000, 88.000000)">
              <g transform="translate(0.000000, 615.000000)">
                <g transform="translate(16.000000, 8.000000)">
                  <polygon points="0 0 40 0 40 40 0 40" />
                  <g
                    transform="translate(10.000000, 9.000000)"
                    stroke={color}
                    strokeLinecap="square"
                    strokeWidth="1.2"
                  >
                    <rect x="0" y="0" width="20" height="22" />
                    <polyline points="6 12 8 14 14 8" />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
    ),
    [Icons.CHECK]: (
      <svg
        onClick={onClick}
        width="16px"
        height="16px"
        viewBox="0 0 16 16"
        version="1.1"
      >
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g transform="translate(-38.000000, -118.000000)">
            <g transform="translate(0.000000, 88.000000)">
              <g>
                <g transform="translate(38.000000, 30.000000)">
                  <g>
                    <circle
                      fill="#FFFFFF"
                      fillRule="nonzero"
                      cx="8"
                      cy="8"
                      r="8"
                    />
                    <circle
                      stroke={color}
                      strokeWidth="1.2"
                      opacity={opacity}
                      fillRule="nonzero"
                      cx="8"
                      cy="8"
                      r="5.4"
                    />
                    <g
                      id="check-small"
                      opacity={opacity}
                      transform="translate(6.000000, 7.000000)"
                      stroke={color}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="1.2"
                    >
                      <polyline points="0 1.14285714 1.42857143 2.57142857 4 0" />
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
    ),
    [Icons.EVENTS]: (
      <svg
        onClick={onClick}
        className={className}
        width="40px"
        height="40px"
        viewBox="0 0 40 40"
        version="1.1"
      >
        <g
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
          strokeLinecap="square"
        >
          <g
            transform="translate(9.000000, 10.000000)"
            stroke={color}
            opacity={opacity}
            strokeWidth="1.2"
          >
            <path d="M0,7 L22,7" />
            <rect x="0" y="2" width="22" height="19" rx="2" />
            <path d="M5,0 L5,3" />
            <path d="M17,0 L17,3" />
          </g>
        </g>
      </svg>
    ),
    [Icons.ABSENCES]: (
      <svg
        onClick={onClick}
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        width="40"
        height="40"
        viewBox="0 0 40 40"
      >
        <g fill="none" fillRule="evenodd">
          <path
            stroke={color}
            opacity={opacity}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.2"
            d="M11 9h18M11 31h18"
          />
          <path
            fill={color}
            opacity={opacity}
            d="M16 28v-.789a1 1 0 0 1 .167-.553l3-4.5a1 1 0 0 1 1.664 0l3 4.5a1 1 0 0 1 .168.555V28H16z"
          />
          <path
            stroke={color}
            opacity={opacity}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.2"
            d="M13 31v-3.789a4 4 0 0 1 .672-2.219L17 20l-3.328-4.992A4 4 0 0 1 13 12.789V9M27 9v3.789a4 4 0 0 1-.672 2.219L23 20l3.328 4.992A4 4 0 0 1 27 27.211V31"
          />
          <path d="M0 0h40v40H0z" />
        </g>
      </svg>
    ),
    [Icons.NOTES]: (
      <svg
        onClick={onClick}
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        width="40"
        height="40"
        viewBox="0 0 40 40"
      >
        <g fill="none" fillRule="evenodd">
          <path d="M0 0h40v40H0z" />
          <path fill={color} opacity={opacity} d="M24 31.5v-6h6z" />
          <path
            stroke={color}
            opacity={opacity}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.2"
            d="M24 31.5v-6h6"
          />
          <path
            stroke={color}
            opacity={opacity}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.2"
            d="M24 31.5H10v-22h20v16z"
          />
        </g>
      </svg>
    ),
    [Icons.MEDICAL_BIG]: (
      <svg
        onClick={onClick}
        className={className}
        width="40px"
        height="40px"
        viewBox="0 0 40 40"
        version="1.1"
      >
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <rect x="0" y="0" width="40" height="40" />
          <g
            transform="translate(8.500000, 9.000000)"
            stroke={color}
            opacity={opacity}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.2"
          >
            <polyline points="7.5 4.5 7.5 0.5 15.5 0.5 15.5 4.5" />
            <rect x="0.5" y="4.5" width="22" height="18" />
            <polygon points="16.5 11.5 13.5 11.5 13.5 8.5 9.5 8.5 9.5 11.5 6.5 11.5 6.5 15.5 9.5 15.5 9.5 18.5 13.5 18.5 13.5 15.5 16.5 15.5" />
          </g>
        </g>
      </svg>
    ),
    [Icons.STREAM]: (
      <svg
        onClick={onClick}
        className={className}
        width="40px"
        height="40px"
        viewBox="0 0 40 40"
        version="1.1"
      >
        <g
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <g
            transform="translate(10.500000, 9.000000)"
            stroke={color}
            opacity={opacity}
            strokeWidth="1.2"
          >
            <rect x="0.5" y="0.5" width="18" height="22" />
            <rect x="4.5" y="4.5" width="10" height="6" />
            <path d="M4.5,14.5 L14.5,14.5" />
            <path d="M4.5,18.5 L14.5,18.5" />
          </g>
        </g>
      </svg>
    ),
    [Icons.CONSENT]: (
      <svg
        onClick={onClick}
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        width="40"
        height="40"
        viewBox="0 0 40 40"
      >
        <g
          fill="none"
          fillRule="evenodd"
          stroke={color}
          opacity={opacity}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.2"
        >
          <path d="M25 10.5h5v21H10v-21h5" />
          <path d="M17 23.5l2 2 4-4M15 9.5v6h3a2 2 0 1 1 4 0h3v-6H15z" />
        </g>
      </svg>
    ),
    [Icons.PAYMENTS]: (
      <svg
        onClick={onClick}
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        width="40"
        height="40"
        viewBox="0 0 40 40"
      >
        <g fill="none" fillRule="evenodd">
          <path d="M0 0h40v40H0z" />
          <g
            stroke={color}
            opacity={opacity}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.2"
            transform="translate(8.5 9)"
          >
            <path d="M5.5 2.5h-3a2 2 0 1 0 0 4M5.5 6.5v-6h14v6" />
            <path d="M22.5 6.5h-20a2 2 0 0 1-2-2v15a3 3 0 0 0 3 3h19v-16z" />
            <circle cx="16.5" cy="14.5" r="2" />
          </g>
        </g>
      </svg>
    ),
    [Icons.POLICIES]: (
      <svg
        onClick={onClick}
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        width="40"
        height="40"
        viewBox="0 0 40 40"
      >
        <g fill="none" fillRule="evenodd">
          <path d="M0 0h40v40H0z" />
          <g
            stroke={color}
            opacity={opacity}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.2"
          >
            <path d="M21.5 15l-2.172 2.172a4 4 0 0 1-5.656 0L13.5 17l4.929-4.929A7.072 7.072 0 0 1 29.5 20.7" />
            <path d="M22.766 18.266l3.613 3.613a3 3 0 0 1 0 4.242l-1.636 1.636a6 6 0 0 1-8.486 0l-5.686-5.686A7.072 7.072 0 0 1 15.5 10M25.891 26.609L22 22.719M23.013 28.965l-3.63-3.63" />
          </g>
        </g>
      </svg>
    ),
    [Icons.BEREAVEMENT]: (
      <svg
        onClick={onClick}
        width="18px"
        height="18px"
        viewBox="0 0 18 18"
        version="1.1"
      >
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g transform="translate(-695.000000, -396.000000)">
            <g transform="translate(360.000000, 277.000000)">
              <g transform="translate(0.000000, 64.000000)">
                <g transform="translate(328.000000, 48.000000)">
                  <g transform="translate(8.000000, 8.000000)">
                    <circle
                      fill={color}
                      opacity={opacity}
                      cx="5"
                      cy="6"
                      r="1"
                    />
                    <circle
                      fill={color}
                      opacity={opacity}
                      cx="11"
                      cy="6"
                      r="1"
                    />
                    <path
                      d="M8,15.5 C4.71646334,15.4972455 1.81702081,13.3575369 0.846300683,10.2207674 C-0.124419447,7.08399787 1.05962412,3.68059364 3.7676525,1.82365989 C6.47568087,-0.0332738497 10.0771042,0.0886673787 12.653326,2.12452148 C15.2295478,4.16037558 16.1806705,7.6360748 15,10.7"
                      stroke={color}
                      opacity={opacity}
                      strokeWidth="1.2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M13.5,13.5 C13.5,12.395 11.5,9.5 11.5,9.5 C11.5,9.5 9.5,12.395 9.5,13.5 C9.5,14.6045695 10.3954305,15.5 11.5,15.5 C12.6045695,15.5 13.5,14.6045695 13.5,13.5 Z"
                      stroke={color}
                      opacity={opacity}
                      strokeWidth="1.2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
    ),
    [Icons.MEDICAL_SMALL]: (
      <svg
        onClick={onClick}
        className={className}
        width="15px"
        height="14px"
        viewBox="0 0 15 14"
        version="1.1"
      >
        <g
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <g
            transform="translate(-369.000000, -350.000000)"
            stroke={color}
            opacity={opacity}
          >
            <g transform="translate(360.000000, 277.000000)">
              <g transform="translate(0.000000, 64.000000)">
                <g>
                  <g transform="translate(9.000000, 9.000000)">
                    <polyline points="5.5 3.5 5.5 0.5 9.5 0.5 9.5 3.5" />
                    <rect x="0.5" y="3.5" width="14" height="10" rx="1" />
                    <path d="M7.5,6.5 L7.5,10.5" />
                    <path d="M5.5,8.5 L9.5,8.5" />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
    ),
    [Icons.PIN]: (
      <svg
        onClick={onClick}
        width="18px"
        height="18px"
        viewBox="0 0 18 18"
        version="1.1"
      >
        <g
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <g
            transform="translate(-367.000000, -396.000000)"
            stroke={color}
            opacity={opacity}
            strokeWidth="1.2"
          >
            <g transform="translate(360.000000, 277.000000)">
              <g transform="translate(0.000000, 64.000000)">
                <g transform="translate(0.000000, 48.000000)">
                  <g transform="translate(8.000000, 8.000000)">
                    <path d="M0.5,5.5 L10.5,15.5" />
                    <path d="M9.5,0.5 L15.5,6.5" />
                    <path d="M2.146,7.146 L11.143,2.143" />
                    <path d="M8.854,13.854 L13.857,4.857" />
                    <path d="M4,12 L0.5,15.5" />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
    ),
    [Icons.PILL]: (
      <svg
        onClick={onClick}
        width="16px"
        height="16px"
        viewBox="0 0 16 16"
        version="1.1"
      >
        <g
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <g
            transform="translate(-696.000000, -349.000000)"
            stroke={color}
            opacity={opacity}
          >
            <g transform="translate(360.000000, 277.000000)">
              <g transform="translate(0.000000, 64.000000)">
                <g transform="translate(328.000000, 0.000000)">
                  <g transform="translate(7.000000, 7.000000)">
                    <path d="M6,6 L12,12" />
                    <rect
                      transform="translate(8.999355, 8.999646) rotate(-45.000000) translate(-8.999355, -8.999646) "
                      x="1.22135495"
                      y="4.75714645"
                      width="15.556"
                      height="8.485"
                      rx="4.2425"
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
    ),
    [Icons.STUDENTS_SMALL]: (
      <svg
        onClick={onClick}
        className={className}
        width="18px"
        height="16px"
        viewBox="0 0 18 16"
        version="1.1"
      >
        <g
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <g
            transform="translate(-1024.000000, -398.000000)"
            stroke={color}
            opacity={opacity}
            strokeWidth="1.2"
          >
            <g transform="translate(360.000000, 277.000000)">
              <g transform="translate(0.000000, 64.000000)">
                <g transform="translate(657.000000, 48.000000)">
                  <g transform="translate(8.000000, 9.000000)">
                    <path d="M12.5,14.5 L15.5,14.5 L15.5,11.281 C15.4999879,10.8223206 15.1879311,10.4224591 14.743,10.311 L11.5,9.5 L11.247,7.726 C12.3141203,7.23830615 12.9990021,6.1732817 13,5 L13,4.126 C13.0282949,2.65431504 12.0129365,1.36763615 10.575,1.053 C10.0487702,0.952931916 9.50544461,0.993638212 9,1.171" />
                    <path d="M9.775,11.793 L7,11 L6.747,9.226 C7.72588794,9.38108672 8.72488904,9.11763782 9.5,8.5 C8.75816304,7.49079157 8.40330515,6.24878895 8.5,5 C8.5,3.34314575 7.15685425,2 5.5,2 C3.84314575,2 2.5,3.34314575 2.5,5 C2.59669485,6.24878895 2.24183696,7.49079157 1.5,8.5 C2.27511096,9.11763782 3.27411206,9.38108672 4.253,9.226 L4,11 L1.225,11.793 C0.795995688,11.9157072 0.50019823,12.3077918 0.5,12.754 L0.5,14.5 L10.5,14.5 L10.5,12.754 C10.4998018,12.3077918 10.2040043,11.9157072 9.775,11.793 Z" />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
    ),
    [Icons.RELIGION]: (
      <svg
        onClick={onClick}
        width="16px"
        height="16px"
        viewBox="0 0 16 16"
        version="1.1"
      >
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g
            transform="translate(-1025.000000, -349.000000)"
            fill={color}
            opacity={opacity}
            fillRule="nonzero"
          >
            <g transform="translate(360.000000, 277.000000)">
              <g transform="translate(0.000000, 64.000000)">
                <g transform="translate(657.000000, 0.000000)">
                  <g transform="translate(8.000000, 8.000000)">
                    <path d="M15.53125,12.0500488 L13.3607178,12.0500488 C13.0211182,10.5473633 11.7419434,4.90136719 10.9356689,1.3428955 C10.7565918,0.552246094 10.065918,0 9.2561035,0 C9.12817381,0 8.99975587,0.0144043125 8.87426756,0.0428466875 C8.52844237,0.121215813 8.2282715,0.297485344 8,0.538818375 C7.7717285,0.297485344 7.47167969,0.121215813 7.1258545,0.0428466875 C7.00036622,0.0144043125 6.87182619,0 6.74401856,0 C5.93420409,0 5.24353028,0.552246094 5.06433106,1.3428955 C4.40991212,4.23132325 2.9991455,10.458374 2.63928222,12.0500488 L0.46875,12.0500488 C0.209838875,12.0500488 0,12.2598877 0,12.5187988 L0,15.53125 C0,15.7901611 0.209838875,16 0.46875,16 L5.48242188,16 C6.53894044,16 7.46899413,15.4484863 8,14.6182861 C8.53100587,15.4484863 9.46105956,16 10.5175781,16 L15.53125,16 C15.7901611,16 16,15.7901611 16,15.53125 L16,12.5187988 C16,12.2598877 15.7901611,12.0500488 15.53125,12.0500488 Z M5.48242188,15.0625 L0.9375,15.0625 L0.9375,12.9875488 L3.013916,12.9875488 C3.23535156,12.9875488 3.42639159,12.8326416 3.47241212,12.6165772 C3.51550294,12.4213867 5.9539795,1.65905762 5.97863769,1.55004881 C6.05908203,1.19519044 6.38098144,0.9375 6.74401856,0.9375 C6.80224609,0.9375 6.861084,0.944091812 6.91870119,0.957153313 C7.27380372,1.03759766 7.53125,1.35974122 7.53088378,1.72326659 C7.53088378,1.72900391 7.53100587,1.73474122 7.53125,1.74060059 L7.53125,6.467041 C7.29541016,6.34570312 7.02844238,6.27673341 6.74548341,6.27673341 C5.795166,6.27673341 5.02221681,7.04980469 5.02221681,8 L5.02221681,10.5091553 C5.02221681,10.7680664 5.23205566,10.9779053 5.49096681,10.9779053 C5.74975587,10.9779053 5.95971681,10.7680664 5.95971681,10.5091553 L5.95971681,8 C5.95971681,7.56677247 6.31213378,7.21423341 6.74548341,7.21423341 C7.17871094,7.21423341 7.53125,7.56677247 7.53125,8 L7.53125,13.0136719 C7.53125,14.1434326 6.61218262,15.0625 5.48242188,15.0625 Z M15.0625,15.0625 L10.5175781,15.0625 C9.38781737,15.0625 8.46875,14.1434326 8.46875,13.0136719 L8.46875,8 C8.46875,7.56677247 8.82128906,7.21423341 9.25451659,7.21423341 C9.68786622,7.21423341 10.0404053,7.56677247 10.0404053,8 L10.0404053,10.5091553 C10.0404053,10.7680664 10.2503662,10.9779053 10.5091553,10.9779053 C10.7680664,10.9779053 10.9779053,10.7680664 10.9779053,10.5091553 L10.9779053,8 C10.9779053,7.04980469 10.204834,6.27673341 9.25451659,6.27673341 C8.97155763,6.27673341 8.70458984,6.34570312 8.46875,6.467041 L8.46875,1.7421875 C8.46899413,1.73596191 8.46911622,1.72961425 8.46911622,1.72326659 C8.46887206,1.35974122 8.72631837,1.03759766 9.08129881,0.957153313 C9.13903809,0.944091812 9.19775391,0.9375 9.2561035,0.9375 C9.61914062,0.9375 9.94091797,1.19519044 10.0213623,1.55004881 C10.0460205,1.65905762 12.4857178,12.4265137 12.5275879,12.6164551 C12.5736084,12.8325195 12.7645264,12.9875488 12.986084,12.9875488 L15.0625,12.9875488 L15.0625,15.0625 Z" />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
    ),
    [Icons.HALF_CIRCLE]: (
      <svg
        onClick={onClick}
        width="40"
        height="40"
        viewBox="0 0 40 40"
        className={className}
      >
        <defs>
          <path
            id="half_circle_a"
            d="M6.5.522a5.5 5.5 0 0 1 0 10.956v.022h-1v-.022A5.5 5.5 0 0 1 5.5.522V.5h1v.022zm-1 9.95V1.528a4.5 4.5 0 0 0 0 8.946z"
          />
        </defs>
        <g fill="none" fillRule="evenodd" transform="translate(14 14)">
          <mask id="half_circle_b" fill="#fff">
            <use xlinkHref="#half_circle_a" />
          </mask>
          <use fill="#383C4C" fillRule="nonzero" xlinkHref="#half_circle_a" />
          <g
            fill={color}
            opacity={opacity}
            fillRule="nonzero"
            mask="url(#half_circle_b)"
          >
            <path d="M-6-6h24v24H-6z" />
          </g>
        </g>
      </svg>
    ),
    [Icons.ALERT]: (
      <svg
        onClick={onClick}
        className={className}
        width="40"
        height="40"
        viewBox="0 0 40 40"
      >
        <g fill="none" fillRule="evenodd" opacity={opacity}>
          <g transform="translate(12.5 12.5)">
            <circle cx="7.5" cy="12" r="1.4" fill={color} fillRule="nonzero" />
            <path
              stroke={color}
              strokeLinecap="square"
              strokeLinejoin="round"
              strokeWidth="2.8"
              d="M7.5 3.5V8"
            />
          </g>
        </g>
      </svg>
    ),
    [Icons.LOCATION_PIN]: (
      <svg
        onClick={onClick}
        className={className}
        width="14px"
        height="16px"
        viewBox="0 0 14 16"
        version="1.1"
      >
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g
            transform="translate(-381.000000, -425.000000)"
            fill={color}
            opacity={opacity}
            fillRule="nonzero"
          >
            <g transform="translate(380.000000, 105.000000)">
              <g transform="translate(1.000000, 320.000000)">
                <path d="M7,0 C3.1,0 0,3.1 0,7 C0,8.9 0.7,10.7 2.1,12 C2.2,12.1 6.2,15.7 6.3,15.8 C6.7,16.1 7.3,16.1 7.6,15.8 C7.7,15.7 11.8,12.1 11.8,12 C13.2,10.7 13.9,8.9 13.9,7 C14,3.1 10.9,0 7,0 Z M7,9 C5.9,9 5,8.1 5,7 C5,5.9 5.9,5 7,5 C8.1,5 9,5.9 9,7 C9,8.1 8.1,9 7,9 Z" />
              </g>
            </g>
          </g>
        </g>
      </svg>
    ),
    [Icons.INFO_LOCKER]: (
      <svg
        onClick={onClick}
        className={className}
        width="40"
        height="40"
        viewBox="0 0 40 40"
      >
        <g fill="none" fillRule="evenodd">
          <path d="M0 0h40v40H0z" />
          <g
            stroke={color}
            opacity={opacity}
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M13.5 13h13v14h-13zM13.5 20h13M18.5 16h3M18.5 23h3" />
          </g>
        </g>
      </svg>
    ),
    [Icons.DASHBOARD]: (
      <svg
        onClick={onClick}
        className={className}
        width="40"
        height="40"
        viewBox="0 0 40 40"
      >
        <g fill="none" fillRule="evenodd">
          <path d="M0 0h40v40H0z" />
          <g
            stroke={color}
            opacity={opacity}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.2"
            transform="translate(12 12)"
          >
            <circle cx="8" cy="8" r="7.5" />
            <path d="M8 2.91v.726M11.6 4.4l-.514.514M13.09 8h-.726M3.636 8H2.91" />
            <circle cx="8" cy="8" r="1.5" />
            <path d="M6.939 6.939L4.5 4.5" />
          </g>
        </g>
      </svg>
    ),
    [Icons.PAPER_PLANE]: (
      <svg
        onClick={onClick}
        className={className}
        width="12px"
        height="12px"
        viewBox="0 0 12 12"
      >
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g transform="translate(-1306.000000, -26.000000)" fillRule="nonzero">
            <g transform="translate(1296.000000, 16.000000)">
              <g
                transform="translate(10.000000, 10.000000)"
                fill={color}
                opacity={opacity}
              >
                <path d="M2.6668433,7.18214381 L2.6668433,10.8664413 C2.6668433,11.3927695 3.26836125,11.6183387 3.64430997,11.24239 L5.37367408,9.21226689 L8.90759204,11.8439079 C9.20835101,12.0694772 9.65948947,11.9190977 9.73467922,11.5431489 L11.9903715,0.640636104 C12.0655613,0.189497642 11.6896126,-0.111261333 11.2384741,0.0391181542 L0.335961248,4.40012329 C-0.0399874706,4.55050278 -0.115177214,5.07683099 0.185581761,5.37758996 L1.38861766,6.27986689 L4.84734587,4.62569252 C5.14810485,4.47531304 5.37367408,4.85126175 5.14810485,5.00164124 L2.6668433,7.18214381 Z" />
              </g>
            </g>
          </g>
        </g>
      </svg>
    ),
    [Icons.SCHOOL]: (
      <svg
        onClick={onClick}
        className={className}
        width="40"
        height="40"
        viewBox="0 0 40 40"
      >
        <g fill="none" fillRule="evenodd">
          <path d="M0 0h40v40H0z" />
          <g
            stroke={color}
            opacity={opacity}
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M26.5 16.5v-4h-3v2h3M23.5 18.5l-3.5-3-3.5 3h-4v9h15v-9z" />
          </g>
        </g>
      </svg>
    ),
    [Icons.LINK]: (
      <svg
        onClick={onClick}
        className={className}
        width="16"
        height="16"
        viewBox="0 0 16 16"
      >
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g transform="translate(-793.000000, -24.000000)">
            <g>
              <g transform="translate(501.000000, 12.000000)">
                <g transform="translate(280.000000, 0.000000)">
                  <g>
                    <g
                      transform="translate(13.000000, 13.000000)"
                      stroke={color}
                      opacity={opacity}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="1.2"
                    >
                      <path d="M11,8 L12.975,5.975 C14.342,4.608 14.342,2.392 12.975,1.025 C11.608,-0.342 9.392,-0.342 8.025,1.025 L6,3" />
                      <path d="M8,11 L5.975,12.975 C4.608,14.342 2.392,14.342 1.025,12.975 C-0.342,11.608 -0.342,9.392 1.025,8.025 L3,6" />
                      <path d="M4,10 L10,4" />
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
    ),
    [Icons.HAMBURGUER]: (
      <svg
        onClick={onClick}
        className={className}
        width="40px"
        height="40px"
        viewBox="0 0 40 40"
        version="1.1"
      >
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <rect x="0" y="0" width="40" height="40" />
          <g
            transform="translate(12.000000, 14.500000)"
            stroke={color}
            opacity={opacity}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.2"
          >
            <path d="M0.5,5.5 L15.5,5.5" />
            <path d="M0.5,0.5 L15.5,0.5" />
            <path d="M0.5,10.5 L15.5,10.5" />
          </g>
        </g>
      </svg>
    ),
    [Icons.TERM_COUNTER]: (
      <svg
        onClick={onClick}
        width="98"
        height="64"
        viewBox="0 0 98 64"
        className={className}
      >
        <g
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
          opacity={opacity}
        >
          <g transform="translate(-162.000000, -425.000000)">
            <g transform="translate(60.000000, 394.000000)">
              <g transform="translate(103.000000, 32.000000)">
                <g transform="translate(0.000000, 15.000000)">
                  <polygon
                    stroke={color}
                    strokeWidth="1.2"
                    fill="#FFFFFF"
                    fillRule="nonzero"
                    points="0 0 28 0 28 18 0 18 4 9"
                  />
                  <rect
                    fill="#00498C"
                    fillRule="nonzero"
                    opacity="0.200000003"
                    transform="translate(22.500000, 9.000000) rotate(-360.000000) translate(-22.500000, -9.000000) "
                    x="21"
                    y="0"
                    width="3"
                    height="18"
                  />
                </g>
                <g transform="translate(68.000000, 15.000000)">
                  <polygon
                    stroke={color}
                    strokeWidth="1.2"
                    fill="#FFFFFF"
                    fillRule="nonzero"
                    transform="translate(14.000000, 9.000000) scale(-1, 1) translate(-14.000000, -9.000000) "
                    points="0 0 28 0 28 18 0 18 4 9"
                  />
                  <rect
                    fill="#00498C"
                    fillRule="nonzero"
                    opacity="0.200000003"
                    transform="translate(5.500000, 9.000000) rotate(-360.000000) translate(-5.500000, -9.000000) "
                    x="4"
                    y="0"
                    width="3"
                    height="18"
                  />
                </g>
                <g transform="translate(24.000000, 0.000000)">
                  <path
                    d="M0.0175767873,1.4141811 C0.0177248004,0.222318532 1.40387187,-0.432881443 2.32512843,0.323454282 C5.52620187,2.95148027 12.6801067,3.09888845 23.6766454,0.505618867 C23.9172488,0.448878316 24.1685358,0.456304487 24.4053676,0.527154472 C35.3440431,3.79953928 42.3941793,3.65426095 45.5633225,0.425645413 C46.4486852,-0.476332053 47.9823735,0.150337693 47.9825566,1.41415189 L47.9869762,43.161416 C48.297274,51.7895167 43.0385579,56.5125964 34.809003,58.276153 C31.1881606,59.0505195 28.3932208,60.027962 24.6242404,61.8832111 C24.2310867,62.0767377 23.7703415,62.0767377 23.3771878,61.8832111 C19.6080165,60.027868 16.8130563,59.0504775 13.191068,58.2760309 C4.96174554,56.512524 -0.297089161,51.7894012 0.0130070036,43.2119648 L0.0175767873,1.4141811 Z"
                    stroke={color}
                    strokeWidth="1.2"
                    fill="#FFFFFF"
                    fillRule="nonzero"
                  />
                  <path
                    d="M4.01464732,5.34751392 C11.0493862,6.28346245 17.6213497,6.03108405 23.7305378,4.59037873 C23.9310407,4.54309493 24.1404465,4.54928341 24.3378064,4.60832506 C30.4148483,6.42631662 36.9640674,7.00603813 43.9854639,6.34748958 L43.9891469,42.1368763 C44.2477283,49.3269603 39.8654649,53.26286 33.0075025,54.7324905 C29.9901338,55.3777959 27.6610173,56.1923313 24.5202003,57.7383722 C24.1925722,57.8996444 23.8086179,57.8996444 23.4809899,57.7383722 C20.3400138,56.192253 18.0108803,55.3777609 14.9925567,54.7323888 C8.13478795,53.2627997 3.7524257,49.326864 4.01083917,42.1790003 L4.01464732,5.34751392 Z"
                    stroke={color}
                    strokeWidth="1.2"
                    fill="#FFFFFF"
                    fillRule="nonzero"
                    opacity="0.300000012"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M39.4,36 C39.4,35.6686292 39.6686292,35.4 40,35.4 C40.3313708,35.4 40.6,35.6686292 40.6,36 C40.6,36.3468721 40.5893527,36.6925095 40.5681414,37.0365894 C40.5477523,37.3673324 40.2631035,37.6189239 39.9323605,37.5985348 C39.6016175,37.5781457 39.350026,37.2934969 39.3704151,36.9627539 C39.3901112,36.6432523 39.4,36.3222384 39.4,36 Z M37.5085367,43.4007862 C37.6680233,43.1103199 38.0327822,43.0041399 38.3232485,43.1636266 C38.6137147,43.3231132 38.7198947,43.6878721 38.5604081,43.9783383 C38.3938647,44.2816568 38.21787,44.5796634 38.0327135,44.8719344 C37.8553775,45.1518605 37.4846934,45.2350262 37.2047674,45.0576903 C36.9248413,44.8803544 36.8416755,44.5096703 37.0190115,44.2297442 C37.1907839,43.9586002 37.3540482,43.6821495 37.5085367,43.4007862 Z M32.2884093,48.9816608 C32.5675324,48.8030637 32.9385879,48.884556 33.1171851,49.1636791 C33.2957822,49.4428022 33.2142899,49.8138578 32.9351668,49.9924549 C32.6438717,50.1788403 32.3468078,50.3560992 32.044398,50.5239407 C31.754661,50.6847485 31.3894224,50.5802307 31.2286146,50.2904938 C31.0678068,50.0007568 31.1723245,49.6355182 31.4620614,49.4747104 C31.7425862,49.3190155 32.0181666,49.1545758 32.2884093,48.9816608 Z M24.9550828,51.3708861 C25.2858358,51.3506604 25.5703603,51.6023926 25.590586,51.9331456 C25.6108116,52.2638986 25.3590795,52.5484231 25.0283265,52.5686487 C24.6929864,52.5891549 24.3561691,52.5996278 24.0177479,52.5999906 C23.9873232,52.5999969 23.9873232,52.5999969 23.9740049,52.5999801 C23.6426344,52.5994718 23.3744176,52.3304309 23.3749259,51.9990605 C23.3754341,51.66769 23.644475,51.3994732 23.9758455,51.3999815 C23.987599,51.3999967 23.987599,51.3999967 24.0168868,51.3999909 C24.3308756,51.3996543 24.6436964,51.3899275 24.9550828,51.3708861 Z M17.4021368,49.9191817 C17.7014697,50.0613309 17.8288923,50.419223 17.6867431,50.718556 C17.5445938,51.0178889 17.1867018,51.1453115 16.8873688,51.0031623 C16.5748086,50.8547316 16.2670528,50.6965527 15.9645244,50.5288891 C15.6746885,50.3682597 15.5699459,50.0030855 15.7305752,49.7132496 C15.8912046,49.4234137 16.2563789,49.3186711 16.5462147,49.4793005 C16.8268193,49.6348137 17.1122573,49.7815218 17.4021368,49.9191817 Z M11.4918256,44.9856856 C11.6853944,45.2546424 11.6242805,45.6295935 11.3553237,45.8231623 C11.086367,46.0167312 10.7114159,45.9556172 10.517847,45.6866605 C10.3157908,45.4059109 10.1225266,45.118925 9.93836896,44.8261227 C9.76194693,44.5456197 9.8463212,44.1752088 10.1268242,43.9987868 C10.4073271,43.8223648 10.777738,43.9067391 10.95416,44.187242 C11.1250212,44.4589035 11.3043404,44.7251819 11.4918256,44.9856856 Z M8.71668483,37.9056685 C8.75725683,38.2345462 8.52353888,38.5340444 8.19466116,38.5746164 C7.86578344,38.6151884 7.56628527,38.3814704 7.52571326,38.0525927 C7.48347252,37.7101882 7.45180833,37.3657664 7.43082424,37.0196715 C7.41076972,36.688908 7.66264907,36.4045139 7.99341251,36.3844594 C8.32417595,36.3644048 8.60857011,36.6162842 8.62862463,36.9470476 C8.64810253,37.2683006 8.67748871,37.5879437 8.71668483,37.9056685 Z"
                    fill="#00498C"
                    fillRule="nonzero"
                    opacity="0.300000012"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
    ),
    [Icons.HASHTAG]: (
      <svg onClick={onClick} className={className} width="40" height="40">
        <g opacity={opacity}>
          <path
            stroke="none"
            fill={color}
            d="m27.09375,17.973787l0,-2.026212l-2.535509,0l0.506696,-4.052425l-2.026786,0l-0.506696,4.052425l-4.052558,0l0.506696,-4.052425l-2.026786,0l-0.506696,4.052425l-3.545862,0l0,2.026212l3.292513,0l-0.505683,4.052425l-2.78683,0l0,2.026212l2.533482,0l-0.506696,4.052425l2.026786,0l0.506696,-4.052425l4.053571,0l-0.50771,4.052425l2.027799,0l0.506696,-4.052425l3.546875,0l0,-2.026212l-3.293527,0l0.50467,-4.052425l2.788857,0zm-5.320312,4.052425l-4.053571,0l0.505683,-4.052425l4.052558,0l-0.50467,4.052425z"
          />
        </g>
      </svg>
    ),
    [Icons.HELP]: (
      <svg
        onClick={onClick}
        className={className}
        width="19px"
        height="19px"
        viewBox="0 0 19 19"
        version="1.1"
      >
        <g
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
          opacity={opacity}
        >
          <g transform="translate(-51.000000, -269.000000)">
            <g transform="translate(24.000000, 56.000000)">
              <g transform="translate(0.000000, 103.000000)">
                <g transform="translate(0.000000, 96.000000)">
                  <g transform="translate(16.000000, 3.000000)">
                    <rect x="0" y="0" width="40" height="40" />
                    <g transform="translate(12.000000, 12.000000)">
                      <circle
                        stroke={color}
                        strokeWidth="1.2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        cx="8.5"
                        cy="8.5"
                        r="8"
                      />
                      <circle
                        fill={color}
                        fillRule="nonzero"
                        cx="8.5"
                        cy="13"
                        r="1"
                      />
                      <path
                        d="M7,4.577 C7.953,3.717 10.018,3.732 10.423,5.212 C10.95,7.134 8.5,7.142 8.5,10"
                        stroke={color}
                        strokeWidth="1.2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
    ),
    [Icons.STAFF]: (
      <svg
        onClick={onClick}
        className={className}
        width="40px"
        height="40px"
        viewBox="0 0 40 40"
        version="1.1"
      >
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g>
            <g
              transform="translate(12.000000, 14.000000)"
              stroke={color}
              opacity={opacity}
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.2"
            >
              <path d="M0.5,12.5 L15.5,12.5" id="Path" />
              <path d="M1.5,10 C1.5,6.41014913 4.41014913,3.5 8,3.5 C11.5898509,3.5 14.5,6.41014913 14.5,10" />
              <circle id="Oval" cx="8" cy="2" r="1.5" />
            </g>
          </g>
        </g>
      </svg>
    ),
    [Icons.BACKPACK]: (
      <svg
        onClick={onClick}
        width="40px"
        height="40px"
        viewBox="0 0 40 40"
        version="1.1"
      >
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g>
            <g
              transform="translate(12.000000, 12.000000)"
              stroke={color}
              opacity={opacity}
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.2"
            >
              <polyline points="5.5 3.5 5.5 0.5 10.5 0.5 10.5 3.5" />
              <path d="M13.5,15.5 L2.5,15.5 L2.5,6.5 C2.5,4.843 3.843,3.5 5.5,3.5 L10.5,3.5 C12.157,3.5 13.5,4.843 13.5,6.5 L13.5,15.5 Z" />
              <path d="M0.5,10.5 L0.5,15.5" />
              <path d="M15.5,10.5 L15.5,15.5" />
              <rect x="5.5" y="6.5" width="5" height="3" />
              <path d="M2.5,12.5 L13.5,12.5" />
            </g>
          </g>
        </g>
      </svg>
    ),
    [Icons.TRANSFER]: (
      <svg
        onClick={onClick}
        className={className}
        width="24px"
        height="24px"
        viewBox="0 0 24 24"
        version="1.1"
      >
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g
            transform="translate(-384.000000, -208.000000)"
            fill={color}
            opacity={opacity}
            fillRule="nonzero"
          >
            <g transform="translate(360.000000, 192.000000)">
              <g transform="translate(24.000000, 16.000000)">
                <path d="M12.0196145,3.48092563e-06 C10.6560615,0.00287371695 9.30310637,0.239640867 8.01961452,0.700003481 L8.01961452,13.0000035 L11.0196145,13.0000035 L7.01961452,18.0000035 L3.01961452,13.0000035 L6.01961452,13.0000035 L6.01961452,1.62400348 C0.637185659,4.71344797 -1.49579696,11.4012008 1.10398087,17.0364792 C3.7037587,22.6717577 10.1759227,25.3896145 16.0196145,23.3000035 L16.0196145,11.0000035 L13.0196145,11.0000035 L17.0196145,6.00000348 L21.0196145,11.0000035 L18.0196145,11.0000035 L18.0196145,22.3760035 C22.7226018,19.6632001 25.0157509,14.1287033 23.6095872,8.88465006 C22.2034235,3.64059682 17.4489215,-0.00411152278 12.0196145,3.48092563e-06 Z" />
              </g>
            </g>
          </g>
        </g>
      </svg>
    ),
    [Icons.DOWNLOAD]: (
      <svg
        onClick={onClick}
        className={className}
        width="16px"
        height="16px"
        viewBox="0 0 16 16"
        version="1.1"
      >
        <g
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <g
            transform="translate(-772.000000, -335.000000)"
            stroke={color}
            opacity={opacity}
          >
            <g transform="translate(360.000000, 295.000000)">
              <g transform="translate(412.000000, 40.000000)">
                <polygon points="4.5 5.5 8 9.5 11.5 5.5 9.5 5.5 9.5 0.5 6.5 0.5 6.5 5.5" />
                <path d="M12.5,0.5 L14.5,0.5 C15.052,0.5 15.5,0.948 15.5,1.5 L15.5,14.5 C15.5,15.052 15.052,15.5 14.5,15.5 L1.5,15.5 C0.948,15.5 0.5,15.052 0.5,14.5 L0.5,1.5 C0.5,0.948 0.948,0.5 1.5,0.5 L3.5,0.5" />
                <path d="M0.5,12.5 L15.5,12.5" />
              </g>
            </g>
          </g>
        </g>
      </svg>
    ),
    [Icons.TEAM_SHEETS]: (
      <svg
        onClick={onClick}
        className={className}
        width="40"
        height="40"
        viewBox="0 0 40 40"
        version="1.1"
      >
        <g
          id="Icons/Outline/24px/icon-sport"
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
        >
          <g id="icon">
            <rect id="padding" x="0" y="0" width="40" height="40" />
            <g
              id="Group"
              transform="translate(9.000000, 9.000000)"
              opacity={opacity}
              fillRule="nonzero"
              stroke="#00498C"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.2"
            >
              <circle
                id="Oval"
                transform="translate(11.244264, 10.717949) rotate(-360.000000) translate(-11.244264, -10.717949) "
                cx="11.2442636"
                cy="10.7179487"
                r="10.7179487"
              />
              <path
                d="M21.5821604,17.0665658 C19.6425932,15.1269985 16.963106,13.9273513 14.0034262,13.9273513 C11.0437464,13.9273513 8.36425918,15.1269985 6.42469196,17.0665658"
                id="Oval-Copy"
                transform="translate(14.003426, 15.496959) rotate(-30.000000) translate(-14.003426, -15.496959) "
              />
              <path
                d="M15.9411348,7.29602276 C14.0015675,5.35645553 11.3220803,4.15680826 8.36240053,4.15680826 C5.40272072,4.15680826 2.72323354,5.35645553 0.783666315,7.29602276"
                id="Oval-Copy-2"
                transform="translate(8.362401, 5.726416) rotate(-210.000000) translate(-8.362401, -5.726416) "
              />
              <path
                d="M11.2442636,1.11123521e-12 L11.2442636,21.4358974"
                id="Line-2"
                transform="translate(11.244264, 10.717949) rotate(-30.000000) translate(-11.244264, -10.717949) "
              />
              <path
                d="M21.9622123,10.7179487 L0.526314857,10.7179487"
                id="Line-2-Copy-4"
                transform="translate(11.244264, 10.717949) rotate(-30.000000) translate(-11.244264, -10.717949) "
              />
            </g>
          </g>
        </g>
      </svg>
    )
  };
  return icons[name] || null;
};

const getInvertedIcon = (props: IIconProps) => {
  const { name, color, opacity, className, onClick } = props;
  const invertedIcons = {
    [Icons.INBOX]: (
      <svg
        onClick={onClick}
        className={className}
        width="40"
        height="40"
        viewBox="0 0 40 40"
      >
        <g fill="none" fillRule="evenodd" opacity={opacity}>
          <path d="M0 0h40v40H0z" />
          <g fill={color} fillRule="nonzero">
            <path d="M27 14H13c-.6 0-1 .4-1 1v1.4l8 4.5 8-4.4V15c0-.6-.4-1-1-1z" />
            <path d="M19.5 22.9L12 18.7V27c0 .6.4 1 1 1h14c.6 0 1-.4 1-1v-8.3l-7.5 4.2c-.28.14-.72.14-1 0z" />
          </g>
        </g>
      </svg>
    ),
    [Icons.FAVOURITES]: (
      <svg
        onClick={onClick}
        className={className}
        width="40"
        height="40"
        viewBox="0 0 40 40"
      >
        <g stroke={color} fill="none" fillRule="evenodd" opacity={opacity}>
          <path
            fill={color}
            fillRule="nonzero"
            d="M27.144 17.05l-4.316-.627-1.931-3.91c-.338-.684-1.456-.684-1.794 0l-1.93 3.91-4.317.627a1.002 1.002 0 0 0-.554 1.707l3.124 3.044-.737 4.3a1 1 0 0 0 1.451 1.053L20 25.125l3.861 2.03c.728.381 1.591-.234 1.451-1.054l-.737-4.299 3.124-3.044a1.003 1.003 0 0 0-.555-1.708z"
          />
        </g>
      </svg>
    ),
    [Icons.IMPORTANT]: (
      <svg
        onClick={onClick}
        className={className}
        width="40"
        height="40"
        viewBox="0 0 40 40"
      >
        <g fill="none" fillRule="evenodd" opacity={opacity}>
          <g transform="translate(12 12)">
            <circle
              stroke={color}
              cx="8"
              cy="8"
              r="7.5"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.2"
            />
            <path
              fill={color}
              fillRule="nonzero"
              d="M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm0 12c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1zm1-3H7V4h2v5z"
            />
          </g>
        </g>
      </svg>
    ),
    [Icons.CALENDAR]: (
      <svg
        onClick={onClick}
        width="40px"
        height="40px"
        viewBox="0 0 40 40"
        version="1.1"
      >
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g>
            <rect x="0" y="0" width="40" height="40" />
            <g
              transform="translate(12.000000, 12.000000)"
              fill={color}
              fillRule="nonzero"
            >
              <path d="M15,2 L13,2 L13,0 L11,0 L11,2 L9,2 L9,0 L7,0 L7,2 L5,2 L5,0 L3,0 L3,2 L1,2 C0.447,2 0,2.447 0,3 L0,15 C0,15.553 0.447,16 1,16 L15,16 C15.553,16 16,15.553 16,15 L16,3 C16,2.447 15.553,2 15,2 Z M14,14 L2,14 L2,6 L14,6 L14,14 Z" />
            </g>
          </g>
        </g>
      </svg>
    ),
    [Icons.MORE]: (
      <svg
        onClick={onClick}
        className={className}
        width="40"
        height="40"
        viewBox="0 0 40 40"
      >
        <g stroke={color} fillRule="evenodd" opacity={opacity}>
          <g
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.2"
            transform="translate(12 18)"
          >
            <circle cx="8" cy="2" r="1.5" />
            <circle cx="14" cy="2" r="1.5" />
            <circle cx="2" cy="2" r="1.5" />
          </g>
        </g>
      </svg>
    ),
    [Icons.READ]: (
      <svg
        onClick={onClick}
        className={className}
        width="40"
        height="40"
        viewBox="0 0 40 40"
      >
        <g stroke={color} fill="none" fillRule="evenodd" opacity={opacity}>
          <circle
            cx="20"
            cy="20"
            r="7.5"
            fill={color}
            fillOpacity=".2"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.2"
          />
        </g>
      </svg>
    ),
    [Icons.HEART]: (
      <svg
        onClick={onClick}
        className={className}
        width="40"
        height="40"
        viewBox="0 0 40 40"
      >
        <g
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
          opacity={opacity}
        >
          <g fill={color} fillRule="nonzero">
            <path d="M26.68175,14.318 C24.92475,12.561 22.07475,12.561 20.31775,14.318 C20.19675,14.439 20.10375,14.577 19.99975,14.707 C19.89575,14.577 19.80275,14.439 19.68175,14.318 C17.92475,12.561 15.07475,12.561 13.31775,14.318 C11.56075,16.075 11.56075,18.925 13.31775,20.682 L19.99975,27 L26.68175,20.682 C28.43875,18.925 28.43875,16.075 26.68175,14.318 Z" />
          </g>
        </g>
      </svg>
    ),
    [Icons.STUDENTS]: (
      <svg
        onClick={onClick}
        className={className}
        width="24px"
        height="19px"
        viewBox="0 0 24 19"
        version="1.1"
      >
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g transform="translate(-24.000000, -107.000000)">
            <g transform="translate(0.000000, 88.000000)">
              <g>
                <g transform="translate(16.000000, 8.000000)">
                  <rect x="0" y="0" width="40" height="40" />
                  <g
                    transform="translate(8.000000, 11.000000)"
                    fill={color}
                    opacity={opacity}
                    fillRule="nonzero"
                  >
                    <path d="M23.371,12.749 L19.629,11.249 C19.2500254,11.0975967 19.001075,10.7310974 19,10.323 L19,9.445 C20.2344135,8.73660134 20.9968908,7.42323424 21,6 L21,4.172 C21.0350064,2.06953771 19.4796496,0.278743 17.393,0.019 C16.269164,-0.0919537075 15.1507914,0.2773164 14.3139802,1.03564679 C13.477169,1.79397719 12.9999004,2.87070023 13,4 L13,6 C13.0031092,7.42323424 13.7655865,8.73660134 15,9.445 L15,10.323 C14.6707586,11.1476934 14.1163411,11.8632385 13.4,12.388 C13.332,12.432 13.266,12.481 13.2,12.526 L14.111,12.891 C15.2536058,13.3429304 16.0030619,14.448269 16,15.677 L16,18 C15.9966856,18.3414397 15.9344378,18.679743 15.816,19 L23,19 C23.5522847,19 24,18.5522847 24,18 L24,13.677 C23.9997412,13.2681728 23.7506505,12.9006748 23.371,12.749 Z" />
                    <path d="M13.371,14.749 L9.629,13.249 C9.25002543,13.0975967 9.00107504,12.7310974 9,12.323 L9,11.872 C10.1569176,11.7685253 11.2714602,11.385916 12.248,10.757 C12.464786,10.5968196 12.6067163,10.3550218 12.6408926,10.0876533 C12.675069,9.82028477 12.598524,9.55056044 12.429,9.341 C11.6254163,8.41246955 11.1265695,7.25943183 11,6.038 C11.0595992,4.6104458 10.329597,3.26570482 9.1,2.538 C7.85276734,1.80304915 6.30790339,1.79047497 5.04887273,2.50502647 C3.78984206,3.21957797 3.00852136,4.55235728 3,6 C2.88437207,7.23589863 2.384661,8.40457212 1.571,9.342 C1.40152519,9.55139561 1.32500215,9.82096334 1.35918208,10.0881711 C1.39336201,10.3553788 1.53527455,10.5970053 1.752,10.757 C2.72853979,11.385916 3.84308244,11.7685253 5,11.872 L5,12.323 C4.99974123,12.7318272 4.75065048,13.0993252 4.371,13.251 L0.629,14.751 C0.250025427,14.9024033 0.00107503532,15.2689026 0,15.677 L0,18 C-4.33869274e-17,18.5522847 0.44771525,19 1,19 L13,19 C13.5522847,19 14,18.5522847 14,18 L14,15.677 C13.9997412,15.2681728 13.7506505,14.9006748 13.371,14.749 Z" />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
    ),
    [Icons.CONTACT]: (
      <svg
        onClick={onClick}
        width="23px"
        height="23px"
        viewBox="0 0 23 23"
        version="1.1"
      >
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g transform="translate(-25.000000, -161.000000)">
            <g transform="translate(0.000000, 88.000000)">
              <g transform="translate(0.000000, 56.000000)">
                <g transform="translate(16.000000, 8.000000)">
                  <rect x="0" y="0" width="40" height="40" />
                  <g
                    transform="translate(9.000000, 9.000000)"
                    fill={color}
                    fillRule="nonzero"
                  >
                    <path d="M23,10 L21,10 C20.9950401,5.58377808 17.4162219,2.00495988 13,2 L13,0 C18.5203344,0.00606237045 22.9939376,4.47966557 23,10 Z" />
                    <path d="M19,10 L17,10 C17,7.790861 15.209139,6 13,6 L13,4 C16.3123376,4.00330738 18.9966926,6.68766243 19,10 Z" />
                    <path d="M14.522,14.471 L12.188,16.771 L6.229,10.812 L8.529,8.478 C8.81348509,8.18860876 8.89487322,7.75598742 8.735,7.383 L6.34,1.793 C6.14431781,1.33738714 5.64431265,1.09398037 5.165,1.221 L0.765,2.383 C0.31219832,2.5001582 0.00108872945,2.9155248 0.016,3.383 C0.295838128,8.49688846 2.42213859,13.3354301 6,17 C9.6657405,20.5783789 14.5058438,22.7043856 19.621,22.983 C20.0884752,22.9979113 20.5038418,22.6868017 20.621,22.234 L21.783,17.834 C21.9100196,17.3546874 21.6666129,16.8546822 21.211,16.659 L15.621,14.264 C15.2467157,14.1025674 14.8119082,14.1844648 14.522,14.471 Z" />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
    ),
    [Icons.DOCTOR]: (
      <svg
        onClick={onClick}
        width="24px"
        height="24px"
        viewBox="0 0 24 24"
        version="1.1"
      >
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g transform="translate(-24.000000, -216.000000)">
            <g transform="translate(0.000000, 88.000000)">
              <g transform="translate(0.000000, 112.000000)">
                <g transform="translate(16.000000, 8.000000)">
                  <rect x="0" y="0" width="40" height="40" />
                  <g
                    transform="translate(20.000000, 20.000000) scale(-1, 1) translate(-20.000000, -20.000000) translate(8.000000, 8.000000)"
                    fill={color}
                    fillRule="nonzero"
                  >
                    <path d="M24,14 C24,11.8 22.2,10 20,10 C17.8,10 16,11.8 16,14 C16,15.9 17.3,17.4 19,17.9 L19,22 L9,22 L9,17 L11.3,17 C12.8,17 14.1,15.9 14.3,14.4 L15.9,3.3 C16,2.7 15.8,2.1 15.4,1.7 C15,1.3 14.4,1 13.8,1 L12,1 C12,0.4 11.6,0 11,0 C10.4,0 10,0.4 10,1 L10,3 C10,3.6 10.4,4 11,4 C11.6,4 12,3.6 12,3 L13.8,3 L12.2,14.1 C12.1,14.6 11.7,15 11.2,15 L4.7,15 C4.2,15 3.8,14.6 3.7,14.1 L2.2,3 L4,3 C4,3.6 4.4,4 5,4 C5.6,4 6,3.6 6,3 L6,1 C6,0.4 5.6,0 5,0 C4.4,0 4,0.4 4,1 L2.2,1 C1.6,1 1,1.3 0.6,1.7 C0.2,2.1 -3.1918912e-16,2.7 0.1,3.3 L1.7,14.4 C2,15.9 3.3,17 4.7,17 L7,17 L7,23 C7,23.6 7.4,24 8,24 L20,24 C20.6,24 21,23.6 21,23 L21,17.9 C22.7,17.4 24,15.9 24,14 Z" />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
    ),
    [Icons.INSURANCE]: (
      <svg
        onClick={onClick}
        width="22px"
        height="22px"
        viewBox="0 0 22 22"
        version="1.1"
      >
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g transform="translate(-25.000000, -274.000000)">
            <g transform="translate(0.000000, 88.000000)">
              <g transform="translate(0.000000, 167.000000)">
                <g transform="translate(16.000000, 9.000000)">
                  <rect x="0" y="0" width="40" height="40" />
                  <g
                    transform="translate(9.000000, 9.000000)"
                    fill={color}
                    fillRule="nonzero"
                  >
                    <path d="M21,4 C17.843,4 14.135,2.889 11.555,1.168 C11.219,0.943 10.782,0.943 10.446,1.168 C7.865,2.889 4.157,4 1,4 C0.448,4 0,4.447 0,5 C0,13.374 3.965,20.073 10.606,22.919 C10.732,22.973 10.866,23 11,23 C11.134,23 11.268,22.973 11.394,22.919 C18.035,20.073 22,13.374 22,5 C22,4.447 21.552,4 21,4 Z M11,20.905 L11,12 L3.141,12 C2.491,10.16 2.107,8.133 2.02,5.967 C5.074,5.772 8.442,4.732 11,3.185 L11,12 L18.859,12 C17.429,16.045 14.709,19.186 11,20.905 Z" />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
    ),
    [Icons.CONDITION]: (
      <svg
        onClick={onClick}
        width="24px"
        height="24px"
        viewBox="0 0 24 24"
        version="1.1"
      >
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g transform="translate(-24.000000, -327.000000)">
            <g transform="translate(0.000000, 88.000000)">
              <g transform="translate(0.000000, 223.000000)">
                <g transform="translate(16.000000, 8.000000)">
                  <rect x="0" y="0" width="40" height="40" />
                  <g
                    transform="translate(8.000000, 8.000000)"
                    fill={color}
                    fillRule="nonzero"
                  >
                    <path d="M21,7 L17,7 L17,3 C17,1.3 15.7,0 14,0 L10,0 C8.3,0 7,1.3 7,3 L7,7 L3,7 C1.3,7 0,8.3 0,10 L0,14 C0,15.7 1.3,17 3,17 L7,17 L7,21 C7,22.7 8.3,24 10,24 L14,24 C15.7,24 17,22.7 17,21 L17,17 L21,17 C22.7,17 24,15.7 24,14 L24,10 C24,8.3 22.7,7 21,7 Z M9,3 C9,2.4 9.4,2 10,2 L14,2 C14.6,2 15,2.4 15,3 L15,7 L9,7 L9,3 Z M3,15 C2.4,15 2,14.6 2,14 L2,10 C2,9.4 2.4,9 3,9 L7,9 L7,15 L3,15 Z M15,21 C15,21.6 14.6,22 14,22 L10,22 C9.4,22 9,21.6 9,21 L9,17 L15,17 L15,21 Z M22,14 C22,14.6 21.6,15 21,15 L17,15 L17,9 L21,9 C21.6,9 22,9.4 22,10 L22,14 Z" />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
    ),
    [Icons.BIG_HEART]: (
      <svg
        onClick={onClick}
        width="22px"
        height="21px"
        viewBox="0 0 22 21"
        version="1.1"
      >
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g transform="translate(-25.000000, -385.000000)">
            <g transform="translate(0.000000, 88.000000)">
              <g transform="translate(0.000000, 279.000000)">
                <g transform="translate(16.000000, 8.000000)">
                  <rect x="0" y="0" width="40" height="40" />
                  <g
                    transform="translate(9.000000, 9.000000)"
                    fill={color}
                    fillRule="nonzero"
                  >
                    <path d="M15.583,1 C13.8563502,1.00960582 12.205596,1.71089724 11,2.947 C9.18752554,1.07331046 6.41971971,0.48618918 4.00264904,1.46268573 C1.58557836,2.43918228 0.00232844617,4.78413009 0,7.391 C0,13.235 9.994,21.447 10.42,21.791 C10.7579573,22.0654762 11.2420427,22.0654762 11.58,21.791 C12.006,21.447 22,13.235 22,7.391 C21.9884235,3.85600174 19.1180161,0.997224481 15.583,1 Z" />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
    ),
    [Icons.ALLERGIES]: (
      <svg
        onClick={onClick}
        width="23px"
        height="24px"
        viewBox="0 0 23 24"
        version="1.1"
      >
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g transform="translate(-25.000000, -439.000000)">
            <g transform="translate(0.000000, 88.000000)">
              <g transform="translate(0.000000, 335.000000)">
                <g transform="translate(16.000000, 8.000000)">
                  <rect x="0" y="0" width="40" height="40" />
                  <g
                    transform="translate(8.000000, 7.000000)"
                    fill={color}
                    fillRule="nonzero"
                  >
                    <path d="M12,13 C11.9994105,11.859321 12.1803394,10.7258147 12.536,9.642 C12.8223786,8.78960954 12.9787981,7.89896199 13,7 C13.094057,5.38169524 12.4921812,3.80030956 11.3459358,2.65406416 C10.1996904,1.50781876 8.61830476,0.905943016 7,1 C5.38169524,0.905943016 3.80030956,1.50781876 2.65406416,2.65406416 C1.50781876,3.80030956 0.905943016,5.38169524 1,7 C1.02120187,7.89896199 1.17762143,8.78960954 1.464,9.642 C1.81966055,10.7258147 2.00058949,11.859321 2,13 C2.00058949,14.140679 1.81966055,15.2741853 1.464,16.358 C1.17762143,17.2103905 1.02120187,18.101038 1,19 C0.905943016,20.6183048 1.50781876,22.1996904 2.65406416,23.3459358 C3.80030956,24.4921812 5.38169524,25.094057 7,25 C8.61830476,25.094057 10.1996904,24.4921812 11.3459358,23.3459358 C12.4921812,22.1996904 13.094057,20.6183048 13,19 C12.9787981,18.101038 12.8223786,17.2103905 12.536,16.358 C12.1803394,15.2741853 11.9994105,14.140679 12,13 Z M5,19 C4.44771525,19 4,18.5522847 4,18 C4,17.4477153 4.44771525,17 5,17 C5.55228475,17 6,17.4477153 6,18 C6,18.5522847 5.55228475,19 5,19 Z M7,22 C6.44771525,22 6,21.5522847 6,21 C6,20.4477153 6.44771525,20 7,20 C7.55228475,20 8,20.4477153 8,21 C8,21.5522847 7.55228475,22 7,22 Z" />
                    <path d="M21.17,5.21 C19.8889895,4.8732611 18.5338065,4.95561641 17.303,5.445 C16.4781857,5.74567482 15.6985694,6.15819515 14.986,6.671 C14.986,6.781 15,6.888 15,7 C14.9799206,8.08772665 14.7972322,9.16632985 14.458,10.2 C14.1557281,11.1026246 14.0010741,12.048108 14,13 C13.9930104,13.7597609 14.0940201,14.5166603 14.3,15.248 L21.17,5.21 Z" />
                    <path d="M14.922,17.883 C14.9721247,18.2532551 14.9981794,18.6263718 15,19 C14.9994201,19.7105115 14.9165343,20.4185642 14.753,21.11 C16.991,20.959 19.79,19.623 21.953,16.459 C23.2897759,14.5815002 24.0055525,12.3327656 24,10.028 C24.0099271,8.70399212 23.5964845,7.4114585 22.82,6.339 L14.922,17.883 Z" />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
    ),
    [Icons.LUNGS]: (
      <svg
        onClick={onClick}
        width="24px"
        height="23px"
        viewBox="0 0 24 23"
        version="1.1"
      >
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g transform="translate(-24.000000, -496.000000)">
            <g transform="translate(0.000000, 88.000000)">
              <g transform="translate(0.000000, 391.000000)">
                <g transform="translate(16.000000, 8.000000)">
                  <rect x="0" y="0" width="40" height="40" />
                  <g
                    transform="translate(8.000000, 9.000000)"
                    fill={color}
                    fillRule="nonzero"
                  >
                    <path d="M23.6,11.9 C22.8,6.7 19.6,3 16,3 C15.6,3 15.3,3.1 15,3.1 L15,5 C15,6.7 16.3,8 18,8 C18.6,8 19,8.4 19,9 C19,9.6 18.6,10 18,10 C15.2,10 13,7.8 13,5 L13,0 L11,0 L11,5 C11,7.8 8.8,10 6,10 C5.4,10 5,9.6 5,9 C5,8.4 5.4,8 6,8 C7.7,8 9,6.7 9,5 L9,3.1 C8.7,3.1 8.4,3 8,3 C4.4,3 1.2,6.7 0.4,11.9 C4.16333634e-16,14.5 0.3,17 1,19 C1.8,21.3 3.3,22.7 5.1,22.9 C5.3,22.9 5.5,22.9 5.8,22.9 C7,22.9 8.1,22.5 9.1,21.6 C10.9,20 12,17.1 12,13.9 C12,17.1 13.1,20 14.9,21.6 C15.9,22.4 17,22.9 18.2,22.9 C18.4,22.9 18.6,22.9 18.9,22.9 C20.7,22.6 22.2,21.2 23,19 C23.7,17 24,14.5 23.6,11.9 Z" />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
    ),
    [Icons.SYRINGE]: (
      <svg
        onClick={onClick}
        width="24px"
        height="24px"
        viewBox="0 0 24 24"
        version="1.1"
      >
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g transform="translate(-24.000000, -551.000000)">
            <g transform="translate(0.000000, 88.000000)">
              <g transform="translate(0.000000, 447.000000)">
                <g transform="translate(16.000000, 8.000000)">
                  <rect x="0" y="0" width="40" height="40" />
                  <g
                    transform="translate(8.000000, 8.000000)"
                    fill={color}
                    fillRule="nonzero"
                  >
                    <path d="M19,8.4 L21.1,6.3 L21.5,6.7 C21.9,7.1 22.5,7.1 22.9,6.7 C23.3,6.3 23.3,5.7 22.9,5.3 L18.7,1 C18.3,0.6 17.7,0.6 17.3,1 C16.9,1.4 16.9,2 17.3,2.4 L17.7,2.8 L15.6,5 L12.4,1.8 C12,1.4 11.4,1.4 11,1.8 C10.6,2.2 10.6,2.8 11,3.2 L13.1,5.3 L12.4,6 L14,7.6 L12.6,9 L11,7.4 L9.4,9 L11,10.6 L9.6,12 L8,10.4 L6.4,12 L8,13.6 L6.6,15 L5,13.4 L3.2,15.2 L5.3,17.3 L1,21.5 C0.6,21.9 0.6,22.5 1,22.9 C1.4,23.3 2,23.3 2.4,22.9 L6.6,18.7 L8.7,20.8 L18.6,10.9 L20.7,13 C21.1,13.4 21.7,13.4 22.1,13 C22.5,12.6 22.5,12 22.1,11.6 L19,8.4 Z" />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
    ),
    [Icons.PAPER]: (
      <svg
        onClick={onClick}
        width="22px"
        height="24px"
        viewBox="0 0 22 24"
        version="1.1"
      >
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g transform="translate(-25.000000, -607.000000)">
            <g transform="translate(0.000000, 88.000000)">
              <g transform="translate(0.000000, 503.000000)">
                <g transform="translate(16.000000, 8.000000)">
                  <polygon points="0 0 40 0 40 40 0 40" />
                  <g
                    transform="translate(9.000000, 8.000000)"
                    fill={color}
                    fillRule="nonzero"
                  >
                    <path d="M5,19 L5,20.5 C5,21.693 3.806,21.947 3.46,21.996 C2.651,21.974 2,21.313 2,20.5 L2,2 L17,2 L17,17 L19,17 L19,1 C19,0.448 18.552,0 18,0 L1,0 C0.448,0 0,0.448 0,1 L0,20.5 C0,22.43 1.57,24 3.5,24 L18.5,24 C20.43,24 22,22.43 22,20.5 L22,19 L5,19 Z" />
                    <rect x="5" y="5" width="9" height="2" />
                    <rect x="5" y="9" width="9" height="2" />
                    <rect x="5" y="13" width="9" height="2" />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
    ),
    [Icons.BIG_STAR]: (
      <svg
        onClick={onClick}
        width="24px"
        height="24px"
        viewBox="0 0 24 24"
        version="1.1"
      >
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g transform="translate(-24.000000, -663.000000)">
            <g transform="translate(0.000000, 88.000000)">
              <g transform="translate(0.000000, 559.000000)">
                <g transform="translate(16.000000, 8.000000)">
                  <polygon points="0 0 40 0 40 40 0 40" />
                  <g
                    transform="translate(7.000000, 8.000000)"
                    fill={color}
                    fillRule="nonzero"
                  >
                    <path d="M24.144,8.541 L17.063,7.512 L13.9,1.1 C13.7128967,0.782301055 13.3717008,0.587272657 13.003,0.587272657 C12.6342992,0.587272657 12.2931033,0.782301055 12.106,1.1 L8.937,7.512 L1.856,8.541 C1.47930492,8.59537284 1.16613267,8.85886572 1.04813497,9.22071117 C0.930137278,9.58255662 1.02777381,9.98001412 1.3,10.246 L6.425,15.24 L5.216,22.293 C5.15172134,22.6681497 5.30598224,23.0472626 5.61392913,23.2709538 C5.92187602,23.4946451 6.33010867,23.5241251 6.667,23.347 L13,20.018 L19.333,23.347 C19.6698913,23.5241251 20.078124,23.4946451 20.3860709,23.2709538 C20.6940178,23.0472626 20.8482787,22.6681497 20.784,22.293 L19.575,15.24 L24.7,10.246 C24.9721422,9.98028862 25.0699882,9.5831977 24.9524522,9.22146684 C24.8349162,8.85973599 24.5223496,8.59599908 24.146,8.541 L24.144,8.541 Z" />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
    ),
    [Icons.DOCUMENT_CHECK]: (
      <svg
        onClick={onClick}
        width="22px"
        height="24px"
        viewBox="0 0 22 24"
        version="1.1"
      >
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g transform="translate(-25.000000, -719.000000)">
            <g transform="translate(0.000000, 88.000000)">
              <g transform="translate(0.000000, 615.000000)">
                <g transform="translate(16.000000, 8.000000)">
                  <polygon points="0 0 40 0 40 40 0 40" />
                  <g
                    transform="translate(9.000000, 8.000000)"
                    fill={color}
                    fillRule="nonzero"
                  >
                    <path d="M21,0 L1,0 C0.447,0 0,0.448 0,1 L0,23 C0,23.552 0.447,24 1,24 L21,24 C21.553,24 22,23.552 22,23 L22,1 C22,0.448 21.553,0 21,0 Z M9.707,15.707 C9.512,15.902 9.256,16 9,16 C8.744,16 8.488,15.902 8.293,15.707 L5.586,13 L7,11.586 L9,13.586 L15,7.586 L16.414,9 L9.707,15.707 Z" />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
    ),
    [Icons.CIRCLE]: (
      <svg
        onClick={onClick}
        width="40"
        height="40"
        viewBox="0 0 40 40"
        className={className}
      >
        <defs>
          <path
            id="inverted_circle_a"
            d="M6.5.522a5.5 5.5 0 0 1 0 10.956v.022h-1v-.022A5.5 5.5 0 0 1 5.5.522V.5h1v.022z"
          />
        </defs>
        <g fill="none" fillRule="evenodd" transform="translate(14 14)">
          <mask id="inverted_circle_b" fill="#fff">
            <use xlinkHref="#inverted_circle_a" />
          </mask>
          <use
            fill="#383C4C"
            fillRule="nonzero"
            xlinkHref="#inverted_circle_a"
          />
          <g
            fill={color}
            opacity={opacity}
            fillRule="nonzero"
            mask="url(#inverted_circle_b)"
          >
            <path d="M-6-6h24v24H-6z" />
          </g>
        </g>
      </svg>
    ),
    [Icons.EVENTS]: (
      <svg
        onClick={onClick}
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        width="40"
        height="40"
        viewBox="0 0 40 40"
      >
        <g fill={color} opacity={opacity} fillRule="nonzero">
          <path d="M27 12v-2a1 1 0 0 0-2 0v2h2zM15 12v-2a1 1 0 1 0-2 0v2h2zM29 32H11a3 3 0 0 1-3-3V16a3 3 0 0 1 3-3h18a3 3 0 0 1 3 3v13a3 3 0 0 1-3 3zm1-14H10v11a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V18z" />
        </g>
      </svg>
    ),
    [Icons.ABSENCES]: (
      <svg
        onClick={onClick}
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        width="40"
        height="40"
        viewBox="0 0 40 40"
      >
        <g fill="none" fillRule="evenodd">
          <path d="M0 0h40v40H0z" />
          <g fill={color} opacity={opacity}>
            <path d="M29 10H11a1 1 0 1 1 0-2h18a1 1 0 0 1 0 2zM29 32H11a1 1 0 0 1 0-2h18a1 1 0 0 1 0 2zM27 14v-2H13v2c0 .197.059.39.168.555L16.8 20l-3.63 5.445c-.11.164-.17.357-.17.555v2h14v-2c0-.197-.059-.39-.168-.555L23.2 20l3.63-5.445c.11-.164.17-.357.17-.555z" />
          </g>
        </g>
      </svg>
    ),
    [Icons.NOTES]: (
      <svg
        onClick={onClick}
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        width="40"
        height="40"
        viewBox="0 0 40 40"
      >
        <g fill="none" fillRule="evenodd">
          <path d="M0 0h40v40H0z" />
          <g fill={color} opacity={opacity}>
            <path d="M23 25a1 1 0 0 1 1-1h7V9a1 1 0 0 0-1-1H10a1 1 0 0 0-1 1v22a1 1 0 0 0 1 1h13v-7z" />
            <path d="M30.414 26H25v5.414z" />
          </g>
        </g>
      </svg>
    ),
    [Icons.MEDICAL_BIG]: (
      <svg
        onClick={onClick}
        className={className}
        width="40px"
        height="40px"
        viewBox="0 0 40 40"
        version="1.1"
      >
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <rect x="0" y="0" width="40" height="40" />
          <g
            transform="translate(8.000000, 8.000000)"
            fill={color}
            opacity={opacity}
            fillRule="nonzero"
          >
            <path d="M23,4 L17,4 L17,1 C17,0.4 16.6,0 16,0 L8,0 C7.4,0 7,0.4 7,1 L7,4 L1,4 C0.4,4 0,4.4 0,5 L0,23 C0,23.6 0.4,24 1,24 L23,24 C23.6,24 24,23.6 24,23 L24,5 C24,4.4 23.6,4 23,4 Z M9,2 L15,2 L15,4 L9,4 L9,2 Z M17,16 L14,16 L14,19 L10,19 L10,16 L7,16 L7,12 L10,12 L10,9 L14,9 L14,12 L17,12 L17,16 Z" />
          </g>
        </g>
      </svg>
    ),
    [Icons.STREAM]: (
      <svg
        onClick={onClick}
        width="40px"
        height="40px"
        viewBox="0 0 40 40"
        version="1.1"
      >
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <rect x="0" y="0" width="40" height="40" />
          <g
            transform="translate(10.000000, 8.000000)"
            fill={color}
            opacity={opacity}
            fillRule="nonzero"
          >
            <path d="M19,0 L1,0 C0.44771525,-3.38176876e-17 0,0.44771525 0,1 L0,23 C0,23.5522847 0.44771525,24 1,24 L19,24 C19.5522847,24 20,23.5522847 20,23 L20,1 C20,0.44771525 19.5522847,3.38176876e-17 19,0 Z M16,20 L4,20 L4,18 L16,18 L16,20 Z M16,15 L4,15 L4,13 L16,13 L16,15 Z M16,10 L4,10 L4,4 L16,4 L16,10 Z" />
          </g>
        </g>
      </svg>
    ),
    [Icons.CONSENT]: (
      <svg
        onClick={onClick}
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        width="40"
        height="40"
        viewBox="0 0 40 40"
      >
        <g fill="none" fillRule="evenodd">
          <path d="M0 0h40v40H0z" />
          <g fill={color} opacity={opacity}>
            <path
              fillRule="nonzero"
              d="M30 8H10a1 1 0 0 0-1 1v22a1 1 0 0 0 1 1h20a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1zm-2 21H12V11h3v3h3a2 2 0 1 1 4 0h3v-3h3v18z"
            />
            <path d="M19 25a.997.997 0 0 1-.707-.293L15.586 22 17 20.586l2 2 4-4L24.414 20l-4.707 4.707A.997.997 0 0 1 19 25z" />
          </g>
        </g>
      </svg>
    ),
    [Icons.PAYMENTS]: (
      <svg
        onClick={onClick}
        className={className}
        width="40px"
        height="40px"
        viewBox="0 0 40 40"
        version="1.1"
      >
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <rect x="0" y="0" width="40" height="40" />
          <g
            transform="translate(8.000000, 8.000000)"
            fill={color}
            opacity={opacity}
            fillRule="nonzero"
          >
            <rect x="6" y="0" width="16" height="4" />
            <path d="M23,6 L3,6 C2.449,6 2,5.551 2,5 C2,4.449 2.449,4 3,4 L4,4 L4,2 L3,2 C1.343,2 0,3.343 0,5 L0,20 C0,22.209 1.791,24 4,24 L23,24 C23.552,24 24,23.552 24,23 L24,7 C24,6.448 23.552,6 23,6 Z M18,17 C16.895,17 16,16.105 16,15 C16,13.895 16.895,13 18,13 C19.105,13 20,13.895 20,15 C20,16.105 19.105,17 18,17 Z" />
          </g>
        </g>
      </svg>
    ),
    [Icons.POLICIES]: (
      <svg
        onClick={onClick}
        className={className}
        width="40px"
        height="40px"
        viewBox="0 0 40 40"
        version="1.1"
      >
        <g
          id="Icons/Filled/24px/icon-policies"
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
        >
          <rect x="0" y="0" width="40" height="40" />
          <g
            transform="translate(7.000000, 8.500000)"
            fill={color}
            opacity={opacity}
            fillRule="nonzero"
          >
            <path d="M17.536,12.41 C17.1436211,12.0310278 16.5199152,12.0364476 16.1341814,12.4221814 C15.7484476,12.8079152 15.7430278,13.4316211 16.122,13.824 L18.942,16.644 L17.625,17.961 L14.805,15.141 C14.5539255,14.8810434 14.1821221,14.7767874 13.8324927,14.8683028 C13.4828632,14.9598183 13.2098183,15.2328632 13.1183028,15.5824927 C13.0267874,15.9321221 13.1310434,16.3039255 13.391,16.555 L15.948,19.113 C15.22712,19.4136087 14.4462688,19.5426665 13.667,19.49 C13.5976978,20.1963429 13.3191408,20.8659243 12.867,21.413 C13.2420385,21.4767243 13.6215968,21.5101655 14.002,21.513 C15.8585071,21.515802 17.6397109,20.7792112 18.952,19.466 L21.06,17.33 C21.4467327,16.9381966 21.4440508,16.3075003 21.054,15.919 L17.536,12.41 Z" />
            <path d="M2.821,11.856 C3.11884565,11.5651313 3.46500169,11.3282699 3.844,11.156 C2.62977345,9.12415174 2.71153099,6.57091317 4.05326087,4.62090947 C5.39499074,2.67090578 7.75039947,1.68208769 10.082,2.09 L10.515,1.657 C10.9383779,1.23273473 11.4022548,0.850915489 11.9,0.517 C8.63063988,-0.710519585 4.94266932,0.304712149 2.76213129,3.03249033 C0.581593261,5.76026851 0.403556208,9.58127953 2.321,12.5 C2.46293982,12.2672284 2.63066532,12.051198 2.821,11.856 Z" />
            <rect
              id="Rectangle-path"
              transform="translate(7.733370, 16.768530) rotate(45.000000) translate(-7.733370, -16.768530) "
              x="1.78636956"
              y="14.1575304"
              width="11.894"
              height="5.222"
              rx="2.611"
            />
            <path d="M22.636,2.364 C19.4840919,-0.787843118 14.3739081,-0.787843118 11.222,2.364 L6.585,7 L7.293,7.707 C8.51276617,8.92378125 10.4872338,8.92378125 11.707,7.707 L13.5,5.916 L21.924,14.492 L22.638,13.778 C25.7898431,10.6260919 25.7898431,5.5159081 22.638,2.364 L22.636,2.364 Z" />
          </g>
        </g>
      </svg>
    ),
    [Icons.HALF_CIRCLE]: (
      <svg
        onClick={onClick}
        width="40"
        height="40"
        viewBox="0 0 40 40"
        className={className}
      >
        <defs>
          <path
            id="half_inverted_circle_a"
            d="M6.5 1.527v8.946a4.5 4.5 0 0 0 0-8.946zm0-1.005a5.5 5.5 0 0 1 0 10.956v.022h-1v-.022A5.5 5.5 0 0 1 5.5.522V.5h1v.022z"
          />
        </defs>
        <g fill="none" fillRule="evenodd" transform="translate(14 14)">
          <mask id="half_inverted_circle_b" fill="#fff">
            <use xlinkHref="#half_inverted_circle_a" />
          </mask>
          <use
            fill="#383C4C"
            fillRule="nonzero"
            xlinkHref="#half_inverted_circle_a"
          />
          <g
            fill={color}
            opacity={opacity}
            fillRule="nonzero"
            mask="url(#half_inverted_circle_b)"
          >
            <path d="M-6-6h24v24H-6z" />
          </g>
        </g>
      </svg>
    ),
    [Icons.DASHBOARD]: (
      <svg
        onClick={onClick}
        className={className}
        width="40px"
        height="40px"
        viewBox="0 0 40 40"
        version="1.1"
      >
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g>
            <rect x="0" y="0" width="40" height="40" />
            <g
              id="speedometer"
              transform="translate(12.000000, 12.000000)"
              fill={color}
              opacity={opacity}
              fillRule="nonzero"
            >
              <path d="M8,0 C3.6,0 0,3.6 0,8 C0,12.4 3.6,16 8,16 C12.4,16 16,12.4 16,8 C16,3.6 12.4,0 8,0 Z M8,10 C6.9,10 6,9.1 6,8 C6,7.8 6,7.7 6.1,7.5 L3.6,5 L5,3.6 L7.5,6.1 C7.7,6 7.8,6 8,6 C9.1,6 10,6.9 10,8 C10,9.1 9.1,10 8,10 Z" />
            </g>
          </g>
        </g>
      </svg>
    ),
    [Icons.INFO_LOCKER]: (
      <svg
        onClick={onClick}
        className={className}
        width="40px"
        height="40px"
        viewBox="0 0 40 40"
        version="1.1"
      >
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g
            transform="translate(13.000000, 12.000000)"
            fill={color}
            opacity={opacity}
            fillRule="nonzero"
          >
            <path d="M14,7 L14,1 C14,0.4 13.6,0 13,0 L1,0 C0.4,0 0,0.4 0,1 L0,7 L14,7 Z M5,2 L9,2 L9,4 L5,4 L5,2 Z" />
            <path d="M0,9 L0,15 C0,15.6 0.4,16 1,16 L13,16 C13.6,16 14,15.6 14,15 L14,9 L0,9 Z M9,13 L5,13 L5,11 L9,11 L9,13 Z" />
          </g>
        </g>
      </svg>
    ),
    [Icons.PEOPLE]: (
      <svg
        onClick={onClick}
        className={className}
        width="40px"
        height="40px"
        viewBox="0 0 40 40"
      >
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <rect x="0" y="0" width="40" height="40" />
          <g
            transform="translate(10.000000, 12.000000)"
            fill={color}
            opacity={opacity}
            fillRule="nonzero"
          >
            <path d="M15.2,12.4 L12.5,10.4 C13.4,9.7 14,8.7 14,7.5 L14,6.7 C14,4.8 12.6,3.1 10.7,3 C8.7,2.9 7,4.5 7,6.5 L7,7.5 C7,8.7 7.6,9.7 8.5,10.4 L5.8,12.5 C5.3,12.9 5,13.5 5,14.1 L5,16 C5,16.6 5.4,17 6,17 L15,17 C15.6,17 16,16.6 16,16 L16,14 C16,13.4 15.7,12.8 15.2,12.4 Z" />
            <path d="M20.1,7.4 L18.3,6.2 C18.7,5.8 19,5.2 19,4.5 L19,3.6 C19,2.4 18.1,1.2 16.9,1 C15.7,0.8 14.7,1.5 14.2,2.4 C15.3,3.4 16,4.8 16,6.4 L16,7.4 C16,8.3 15.8,9.2 15.4,9.9 C15.4,9.9 16.6,10.8 16.6,10.9 L20,10.9 C20.6,10.9 21,10.5 21,9.9 L21,9.1 C21,8.4 20.7,7.8 20.1,7.4 Z" />
            <path
              d="M6.1,7.4 L4.3,6.2 C4.7,5.8 5,5.2 5,4.5 L5,3.6 C5,2.4 4.1,1.2 2.9,1 C1.7,0.8 0.7,1.5 0.2,2.4 C1.3,3.4 2,4.8 2,6.4 L2,7.4 C2,8.3 1.8,9.2 1.4,9.9 C1.4,9.9 2.6,10.8 2.6,10.9 L6,10.9 C6.6,10.9 7,10.5 7,9.9 L7,9.1 C7,8.4 6.7,7.8 6.1,7.4 Z"
              transform="translate(3.600000, 5.932819) scale(-1, 1) translate(-3.600000, -5.932819)"
            />
          </g>
        </g>
      </svg>
    )
  };
  return invertedIcons[name] || getIcon({ name, color, className, onClick });
};

const Icon = (props: IProps) => {
  const {
    name,
    className,
    color,
    opacity = 1,
    theme,
    inverted = false,
    onClick
  } = props;
  const iconColor = color || theme.colors.primary.main;
  return inverted
    ? getInvertedIcon({ name, color: iconColor, opacity, className, onClick })
    : getIcon({ name, color: iconColor, opacity, className, onClick });
};

export default withTheme(Icon);
